/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
// Angular
// noinspection RedundantIfStatementJS,JSUnusedLocalSymbols,JSNonASCIINames,JSUnusedGlobalSymbols,UnnecessaryLocalVariableJS,JSDeprecatedSymbols,JSUnresolvedReference

// Material
import { SelectionModel } from '@angular/cdk/collections';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { DatePipe, formatCurrency, formatDate } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import {
  MatLegacyAutocomplete as MatAutocomplete,
  MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent,
} from '@angular/material/legacy-autocomplete';
import { MatLegacyChipInputEvent as MatChipInputEvent } from '@angular/material/legacy-chips';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
// NGRX
import { select, Store } from '@ngrx/store';
import { saveAs } from 'file-saver';
// LODASH
import { isEmpty, orderBy } from 'lodash';
import * as moment from 'moment';
import {
  BehaviorSubject,
  fromEvent,
  merge,
  Observable,
  of,
  Subject,
  Subscription,
} from 'rxjs';
// RXJS
import {
  debounceTime,
  delay,
  distinctUntilChanged,
  finalize,
  last,
  map,
  skip,
  take,
  takeUntil,
  takeWhile,
  tap,
} from 'rxjs/operators';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

// Services
import {
  LayoutUtilsService,
  MessageType,
  QueryParamsModel,
} from '../../../../../core/_base/crud';
import { SubheaderService } from '../../../../../core/_base/layout';
import {
  AllUsersLoaded,
  AuthService,
  selectUserById,
  selectUsersInStore,
  User,
  UserActionTypes,
} from '../../../../../core/auth';
import { AppState } from '../../../../../core/reducers';
// Models and selectors
import {
  ActionFail,
  ActionRefresh,
  ActionSuccess,
  AError,
  CheckKgByXLS,
  CheckKgByXLS_ACS,
  CheckReturned,
  CSError,
  EError,
  FetchVoucher,
  GCActionFail,
  GCActionSuccess,
  GConfig,
  GConfigActionTypes,
  GConfigUpdate,
  GotVoucher,
  Liquidate,
  LiquidationFail,
  LiquidationSuccess,
  MarkAsApprovedByXLS_GENIKI,
  MarkAsPaidByXLS,
  MarkAsPaidByXLS_ACS,
  MarkAsPaidByXLS_CS,
  MarkAsPaidByXLS_GENIKI,
  MarkAsPaidByXLS_SPDX,
  MarkAsPaidByXLS_TAXY,
  MarkCancellationPending,
  MarkClarification,
  MarkInvoiced,
  MarkPaid,
  MarkPaidApproved,
  MarkPrepaid,
  MarkPrereturn,
  MarkProcessed,
  MarkReturned,
  MassMarkCancellationPending,
  MassMarkInvoiced,
  MassMarkPaid,
  MassMarkPaidApproved,
  MassMarkPrepaid,
  MassMarkProcessed,
  ReturnDeliveredXLS,
  ScriptService,
  selectFinancialFilters,
  selectGConfigById,
  selectLiquidationInProgress,
  selectShipmentById,
  selectUserFinancialFilters,
  SendDeliveredXLS,
  SError,
  SetFinancialFilters,
  SetUserFinancialFilters,
  Shipment,
  ShipmentActionTypes,
  ShipmentCancel,
  ShipmentCheckWeight,
  ShipmentMassCheckWeight,
  ShipmentsPageRequested,
  SWChargesDataSource,
  ToggleReturnDelivered,
  ToggleSendDelivered,
  UNFError,
  UnMarkPrepaid,
  UnMarkPrereturn,
  ValidateSPDX,
} from '../../../../../core/ronex';
import { MarkAsPaidByXLS_ELTA2 } from '../../../../../core/ronex/_actions/shipment.actions';
//import * as fs from 'file-saver';
//import * as XLSX from 'xlsx';

//import pdfMake from 'pdfmake/build/pdfmake';
//import pdfFonts from 'pdfmake/build/vfs_fonts';
//pdfMake.vfs = pdfFonts.pdfMake.vfs;
declare let pdfMake: any;
declare let pdfFonts: any;

// noinspection NonAsciiCharacters
@Component({
  selector: 'kt-shipments-financial',
  templateUrl: './shipments-financial.component.html',
  styleUrls: ['./shipments-financial.component.scss'],
})
export class ShipmentsFinancialComponent implements OnInit, OnDestroy {
  @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand;

  dataSource: SWChargesDataSource;
  displayedColumns = [
    'select',
    'recipient_name',
    'vg_code',
    '_status',
    'date_approved',
    'cod_ammount',
    'prereturn_ammount',
    'cost',
    'is_delivered',
    'actions',
  ];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('sort1', { static: true }) sort: MatSort;
  // Filter fields
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  @ViewChild('searchInputTel', { static: true }) searchInputTel: ElementRef;

  lastQuery: QueryParamsModel;
  // Selection
  selection = new SelectionModel<Shipment>(true, []);
  bigBucket: Array<any> = [];
  shipmentsResult: Shipment[] = [];
  adminView = false;
  serverError: Subject<any>;
  customWarning: Subject<any>;
  customInfo: Subject<any>;
  customInfo2: Subject<any>;
  customInfo3: Subject<any>;
  customInfo4: Subject<any>;
  isPrinting: BehaviorSubject<boolean>;
  curr_mask = createNumberMask({
    prefix: '€ ',
    allowDecimal: true,
    decimalLimit: 2,
    //requireDecimal: true
  });
  curr_mask1 = createNumberMask({
    suffix: ' €',
    prefix: '',
    thousandsSeparatorSymbol: '',
    allowDecimal: true,
    decimalLimit: 2,
    //requireDecimal: true
    allowNegative: true,
  });
  extraCharges: Array<any> = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  usrCtrl = new UntypedFormControl();
  _usrCtrl = new UntypedFormControl();
  filteredOptions: Observable<User[]>;
  _ab_filteredOptions: Observable<User[]>;
  fUsers: User[] = [];
  fabUsers: User[] = [];
  fStatus: Array<string> = [
    'PROCESSED',
    'PAID',
    'PAID_APPROVED',
    'INVOICED',
    'RETURNED',
    'CANCELLATION_PENDING',
    'CANCELLED',
    'CLARIFICATION',
  ];
  fvg_codes: Array<string> = [];
  dpFA: any;
  dpTA: any;
  dpFP: any;
  dpTP: any;
  dpFI: any;
  dpTI: any;
  dpFR: any;
  dpTR: any;
  dpFSD: any;
  dpTSD: any;
  dpFRD: any;
  dpTRD: any;
  dpFAD: any;
  dpTAD: any;
  sDl = true;
  sprepaid = true;
  oprepaid = false;
  delivered = true;
  odelivered = false;
  returned = true;
  oreturned = false;
  odsr = false;
  arsr = false;
  ord = false;
  snd_del = false;
  osp = false;
  nocod = false;
  ocod = false;
  diffinvw = false;
  courier: string;
  @ViewChild('usrInput') usrInput: ElementRef<HTMLInputElement>;
  @ViewChild('_usrInput') _usrInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  // Subscriptions
  private subscriptions: Subscription[] = [];

  // Liquidation state management
  isLiquidationInProgress$ = this.store.pipe(
    select(selectLiquidationInProgress)
  );
  private pendingLiquidationFiles: {
    codFile: Blob;
    chargesFile: Blob;
    receiptFile: Blob;
    user: User;
  } | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>,
    private router: Router,
    private layoutUtilsService: LayoutUtilsService,
    private subheaderService: SubheaderService,
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
    private actions$: Actions,
    private auth: AuthService,
    private dp: DatePipe,
    private scriptService: ScriptService
  ) {
    this.scriptService
      .load('pdfMake')
      .then(() => this.scriptService.load('vfsFonts'));
  }

  ngOnInit() {
    if (this.router.url.startsWith('/shipment-management/admin')) {
      this.adminView = true;
      //this.store.dispatch( new AllUsersRequested());
      this.displayedColumns = [
        'select',
        'vg_code',
        '_status',
        'date_approved',
        'date_paid',
        'cod_ammount',
        'prereturn_ammount',
        'cost',
        'prepaid_ammount',
        'is_delivered',
        'actions',
      ];
    } else {
      this.adminView = false;
    }

    this.clearExtraCharges();

    this.serverError = new Subject();
    this.serverError.next(false);
    this.customWarning = new Subject();
    this.customWarning.next(false);
    this.customInfo = new Subject();
    this.customInfo.next(false);
    this.customInfo2 = new Subject();
    this.customInfo2.next(false);
    this.customInfo3 = new Subject();
    this.customInfo3.next(false);
    this.customInfo4 = new Subject();
    this.customInfo4.next(false);

    this.isPrinting = new BehaviorSubject<boolean>(false);
    this.isPrinting.next(false);

    const ss = this.actions$
      .pipe(
        ofType<ActionSuccess>(ShipmentActionTypes.ActionSuccess),
        tap(({ payload }) => {
          this.layoutUtilsService.showActionNotification(
            payload.result,
            MessageType.Delete,
            5000,
            true,
            true
          );
          this.clearSelection();
        })
      )
      .subscribe();
    this.subscriptions.push(ss);

    const sf = this.actions$
      .pipe(
        ofType<ActionFail>(ShipmentActionTypes.ActionFail),
        tap(({ payload }) => {
          if (
            // eslint-disable-next-line no-prototype-builtins
            payload.result.hasOwnProperty('error') &&
            // eslint-disable-next-line no-prototype-builtins
            payload.result.error.hasOwnProperty('detail')
          ) {
            this.serverError.next(payload.result.error.detail);
          } else {
            this.serverError.next(
              'Συνέβη ένα σφάλμα με την μεταβολή των δεδομένων. Παρακαλώ ξαναπροσπαθήστε.'
            );
          }
          // eslint-disable-next-line no-prototype-builtins
          if (payload.result.hasOwnProperty('ref_s') && payload.result.ref_s) {
            this.loadShipmentsList();
          }
        })
      )
      .subscribe();
    this.subscriptions.push(sf);

    const se = this.actions$
      .pipe(
        ofType<SError>(ShipmentActionTypes.SError),
        tap(({ payload }) => {
          this.customInfo.next(payload.result);
        })
      )
      .subscribe();
    this.subscriptions.push(se);
    const ee = this.actions$
      .pipe(
        ofType<EError>(ShipmentActionTypes.EError),
        tap(({ payload }) => {
          this.customInfo2.next(payload.result);
        })
      )
      .subscribe();
    this.subscriptions.push(ee);
    const cse = this.actions$
      .pipe(
        ofType<CSError>(ShipmentActionTypes.CSError),
        tap(({ payload }) => {
          this.customInfo3.next(payload.result);
        })
      )
      .subscribe();
    this.subscriptions.push(cse);
    const ae = this.actions$
      .pipe(
        ofType<AError>(ShipmentActionTypes.AError),
        tap(({ payload }) => {
          this.customInfo3.next(payload.result);
        })
      )
      .subscribe();
    this.subscriptions.push(ae);
    const unfe = this.actions$
      .pipe(
        ofType<UNFError>(ShipmentActionTypes.UNFError),
        tap(({ payload }) => {
          this.customInfo4.next(payload.result);
        })
      )
      .subscribe();
    this.subscriptions.push(ae);
    const arf = this.actions$
      .pipe(
        ofType<ActionRefresh>(ShipmentActionTypes.ActionRefresh),
        tap(({ payload }) => {
          this.loadShipmentsList();
        })
      )
      .subscribe();
    this.subscriptions.push(arf);

    const sortSubscription = this.sort.sortChange.subscribe(
      () => (this.paginator.pageIndex = 0)
    );
    this.subscriptions.push(sortSubscription);

    const paginatorSubscriptions = merge(
      this.sort.sortChange,
      this.paginator.page
    )
      .pipe(
        tap(() => {
          this.loadShipmentsList();
        })
      )
      .subscribe();
    this.subscriptions.push(paginatorSubscriptions);

    // Filtration, bind to searchInput
    const searchSubscription = fromEvent(
      this.searchInput.nativeElement,
      'keyup'
    )
      .pipe(
        debounceTime(250),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0;
          this.loadShipmentsList();
        })
      )
      .subscribe();
    this.subscriptions.push(searchSubscription);

    const searchSubscriptionTel = fromEvent(
      this.searchInputTel.nativeElement,
      'keyup'
    )
      .pipe(
        debounceTime(250),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0;
          this.loadShipmentsList();
        })
      )
      .subscribe();
    this.subscriptions.push(searchSubscriptionTel);

    // Subscribe to liquidation-specific actions
    this.actions$
      .pipe(
        ofType<LiquidationSuccess>(ShipmentActionTypes.LiquidationSuccess),
        takeUntil(this.destroy$),
        tap(() => {
          this.onLiquidationSuccess();
        })
      )
      .subscribe();

    this.actions$
      .pipe(
        ofType<LiquidationFail>(ShipmentActionTypes.LiquidationFail),
        takeUntil(this.destroy$),
        tap(() => {
          this.onLiquidationFailed();
        })
      )
      .subscribe();

    // Set title to page breadCrumbs
    this.subheaderService.setTitle('Οικονομική Διαχείριση');

    let fres: Observable<any>;
    if (this.adminView) {
      fres = this.store.pipe(select(selectFinancialFilters));
    } else {
      fres = this.store.pipe(select(selectUserFinancialFilters));
    }

    // Init DataSource
    this.dataSource = new SWChargesDataSource(this.store, this.actions$);
    const entitiesSubscription = this.dataSource.entitySubject
      .pipe(skip(1), distinctUntilChanged())
      .subscribe(res => {
        this.shipmentsResult = res;
        this.restoreSelection();
      });
    this.subscriptions.push(entitiesSubscription);

    //Action will be dispatched from datasource
    this.actions$
      .pipe(ofType<AllUsersLoaded>(UserActionTypes.AllUsersLoaded), take(1))
      .subscribe(() => {
        fres
          .pipe(
            take(1),
            tap(res => this.restore_filters(res)),
            tap(() => this.loadShipmentsList())
          )
          .subscribe();
      });
  }

  /**
   * On Destroy
   */
  ngOnDestroy() {
    this.subscriptions.forEach(el => el.unsubscribe());
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Extra charges
  addExtraCharge() {
    this.extraCharges.push({
      id: this.guid(),
      reason: undefined,
      charge: undefined,
    });
    console.log(this.extraCharges);
  }

  removeExtraCharge(id: string) {
    this.extraCharges = this.extraCharges.filter(x => x.id != id);
  }

  clearExtraCharges() {
    this.extraCharges.splice(0, this.extraCharges.length);
    //console.log(this.extraCharges);
  }

  restore_filters(res: any) {
    if (!isEmpty(res)) {
      this.sort.direction = res.sortOrder;
      this.sort.active = res.sortField;
      this.paginator.pageIndex = res.pageNumber;
      this.paginator.pageSize = res.pageSize;

      if ('_status' in res.filter) {
        this.fStatus = [...res.filter._status];
      }

      if ('is_prepaid' in res.filter) {
        this.sprepaid = res.filter.is_prepaid;
      }

      if ('is_returned' in res.filter) {
        this.returned = res.filter.is_returned;
      }

      if ('is_delivered' in res.filter) {
        this.delivered = res.filter.is_delivered;
      }

      if ('only_prepaid' in res.filter) {
        this.oprepaid = res.filter.only_prepaid;
      }

      if ('only_returned' in res.filter) {
        this.oreturned = res.filter.only_returned;
      }

      if ('odsr' in res.filter) {
        this.odsr = res.filter.odsr;
      }

      if ('arsr' in res.filter) {
        this.arsr = res.filter.arsr;
      }

      if ('only_delivered' in res.filter) {
        this.odelivered = res.filter.only_delivered;
      }

      if ('ord' in res.filter) {
        this.ord = res.filter.ord;
      }

      if ('snd_del' in res.filter) {
        this.snd_del = res.filter.snd_del;
      }

      if ('osp' in res.filter) {
        this.osp = res.filter.osp;
      }

      if ('nocod' in res.filter) {
        this.nocod = res.filter.nocod;
      }

      if ('ocod' in res.filter) {
        this.ocod = res.filter.ocod;
      }

      if ('diffinvw' in res.filter) {
        this.diffinvw = res.filter.diffinvw;
      }

      if ('recipient_name' in res.filter) {
        this.searchInput.nativeElement.value = res.filter.recipient_name;
      }

      if ('recipient_tel' in res.filter) {
        this.searchInputTel.nativeElement.value = res.filter.recipient_tel;
      }

      if ('dpfa' in res.filter) {
        this.dpFA = moment(res.filter.dpfa);
      }

      if ('dpta' in res.filter) {
        this.dpTA = moment(res.filter.dpta);
      }

      if ('dpfp' in res.filter) {
        this.dpFP = moment(res.filter.dpfp);
      }

      if ('dptp' in res.filter) {
        this.dpTP = moment(res.filter.dptp);
      }

      if ('dpfi' in res.filter) {
        this.dpFI = moment(res.filter.dpfi);
      }

      if ('dpti' in res.filter) {
        this.dpTI = moment(res.filter.dpti);
      }

      if ('dpfr' in res.filter) {
        this.dpFR = moment(res.filter.dpfr);
      }

      if ('dptr' in res.filter) {
        this.dpTR = moment(res.filter.dptr);
      }

      if ('dpfsd' in res.filter) {
        this.dpFSD = moment(res.filter.dpfsd);
      }

      if ('dptsd' in res.filter) {
        this.dpTSD = moment(res.filter.dptsd);
      }

      if ('dpfrd' in res.filter) {
        this.dpFRD = moment(res.filter.dpfrd);
      }

      if ('dptrd' in res.filter) {
        this.dpTRD = moment(res.filter.dptrd);
      }

      if ('dpfad' in res.filter) {
        this.dpFAD = moment(res.filter.dpfad);
      }

      if ('dptad' in res.filter) {
        this.dpTAD = moment(res.filter.dptad);
      }

      if ('uids' in res.filter) {
        res.filter.uids.forEach(uid => {
          this.store
            .pipe(
              select(selectUserById(uid)),
              take(1),
              tap(res => this.fUsers.push(res))
            )
            .subscribe();
        });
      }

      if ('_ab_uids' in res.filter) {
        res.filter._ab_uids.forEach(uid => {
          this.store
            .pipe(
              select(selectUserById(uid)),
              take(1),
              tap(res => this.fabUsers.push(res))
            )
            .subscribe();
        });
      }

      if ('vg_codes' in res.filter) {
        this.fvg_codes = [...res.filter.vg_codes];
      }

      if ('courier' in res.filter) {
        this.courier = res.filter.courier;
      }

      this.cdr.detectChanges();
    } else {
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 50;
      this.sort.active = 'date_created';
      this.sort.direction = 'desc';
    }
  }

  //Filter shit here

  clearFilters() {
    if (this.adminView) {
      this.store.dispatch(new SetFinancialFilters({ filters: {} }));
    } else {
      this.store.dispatch(new SetUserFinancialFilters({ filters: {} }));
    }

    const url = this.router.url;
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigateByUrl(url));
  }

  vg_add(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.fvg_codes.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  vg_remove(code: string) {
    const index = this.fvg_codes.indexOf(code);
    if (index >= 0) {
      this.fvg_codes.splice(index, 1);
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  filterUsers(event) {
    const val = event.target.value;
    this.filteredOptions = this._filter(val);
  }

  _ab_filterUsers(event) {
    const val = event.target.value;
    this._ab_filteredOptions = this._ab_filter(val);
  }

  _filter(val: any): Observable<User[]> {
    if (typeof val === 'object') {
      return of(null);
    } else {
      return this.store.pipe(
        select(selectUsersInStore),
        map(res => res.items),
        map((res: Array<User>) => res.filter((usr: User) => usr.id != 1)),
        map((res: Array<User>) =>
          res.filter((usr: User) => !this.fUsers.some(el => el.id === usr.id))
        ),
        map((res: Array<User>) =>
          res.filter(
            (usr: User) =>
              usr.id == val ||
              usr.kap == val ||
              usr.firstname.match(new RegExp(val, 'i')) ||
              usr.lastname.match(new RegExp(val, 'i')) ||
              usr.email.match(new RegExp(val, 'i'))
          )
        ),
        take(1),
        map(res => orderBy(res, ['id'], ['asc']))
      );
    }
  }

  _ab_filter(val: any): Observable<User[]> {
    if (typeof val === 'object') {
      return of(null);
    } else {
      return this.store.pipe(
        select(selectUsersInStore),
        map(res => res.items),
        map((res: Array<User>) => res.filter((usr: User) => usr.id != 1)),
        map((res: Array<User>) =>
          res.filter((usr: User) => !this.fabUsers.some(el => el.id === usr.id))
        ),
        map((res: Array<User>) =>
          res.filter(
            (usr: User) =>
              usr.id == val ||
              usr.kap == val ||
              usr.firstname.match(new RegExp(val, 'i')) ||
              usr.lastname.match(new RegExp(val, 'i')) ||
              usr.email.match(new RegExp(val, 'i'))
          )
        ),
        take(1),
        map(res => orderBy(res, ['id'], ['asc']))
      );
    }
  }

  refs(): void {
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  courierChange($event) {
    this.loadShipmentsList();
  }

  remove(usr: User): void {
    const index = this.fUsers.indexOf(usr);
    if (index >= 0) {
      this.fUsers.splice(index, 1);
      this.filteredOptions = this._filter('');
      this.paginator.pageIndex = 0;
      this.clearSelection();
      this.clearExtraCharges();
      this.loadShipmentsList();
    }
  }

  _ab_remove(usr: User): void {
    const index = this.fabUsers.indexOf(usr);
    if (index >= 0) {
      this.fabUsers.splice(index, 1);
      this._ab_filteredOptions = this._ab_filter('');
      this.paginator.pageIndex = 0;
      this.clearSelection();
      this.loadShipmentsList();
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.fUsers.push(event.option.value);
    this.usrInput.nativeElement.value = '';
    this.usrCtrl.setValue(null);
    this.paginator.pageIndex = 0;
    this.clearSelection();
    this.clearExtraCharges();
    this.loadShipmentsList();
  }

  _ab_selected(event: MatAutocompleteSelectedEvent): void {
    this.fabUsers.push(event.option.value);
    this._usrInput.nativeElement.value = '';
    this._usrCtrl.setValue(null);
    this.paginator.pageIndex = 0;
    this.clearSelection();
    this.loadShipmentsList();
  }

  prepStatusChanged(event) {
    if (event.source._checked) {
      this.sprepaid = true;
    } else {
      this.sprepaid = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  oprepStatusChanged(event) {
    if (event.source._checked) {
      this.oprepaid = true;
    } else {
      this.oprepaid = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  deliveredStatusChanged(event) {
    if (event.source._checked) {
      this.delivered = true;
    } else {
      this.delivered = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  odeliveredStatusChanged(event) {
    if (event.source._checked) {
      this.odelivered = true;
    } else {
      this.odelivered = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  returnedStatusChanged(event) {
    if (event.source._checked) {
      this.returned = true;
    } else {
      this.returned = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  oreturnedStatusChanged(event) {
    if (event.source._checked) {
      this.oreturned = true;
    } else {
      this.oreturned = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  odsrStatusChanged(event) {
    if (event.source._checked) {
      this.odsr = true;
    } else {
      this.odsr = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  arsrStatusChanged(event) {
    if (event.source._checked) {
      this.arsr = true;
    } else {
      this.arsr = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  ordStatusChanged(event) {
    if (event.source._checked) {
      this.ord = true;
    } else {
      this.ord = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  sendDeliveredStatusChanged(event) {
    if (event.source._checked) {
      this.snd_del = true;
    } else {
      this.snd_del = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  ospStatusChanged(event) {
    if (event.source._checked) {
      this.osp = true;
    } else {
      this.osp = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  nocodStatusChanged(event) {
    if (event.source._checked) {
      this.nocod = true;
    } else {
      this.nocod = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  oCodStatusChanged(event) {
    if (event.source._checked) {
      this.ocod = true;
    } else {
      this.ocod = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  withDiffInvWeight(event) {
    if (event.source._checked) {
      this.diffinvw = true;
    } else {
      this.diffinvw = false;
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  fStatusChanged(event) {
    if (event.source._checked) {
      this.fStatus = [...this.fStatus, event.value];
    } else {
      this.fStatus = this.fStatus.filter(e => e !== event.value);
    }

    if (!this.adminView && event.value === 'PROCESSED') {
      if (event.source._checked) {
        this.fStatus = [...this.fStatus, 'PAID'];
      } else {
        this.fStatus = this.fStatus.filter(e => e !== 'PAID');
      }
    }

    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpFAe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpFA = event.value || undefined;
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpTAe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpTA = event.value || undefined;
    if (this.dpTA) {
      this.dpTA = this.dpTA
        .add(23, 'hours')
        .add(59, 'minutes')
        .add(59, 'seconds');
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpFRe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpFA = event.value || undefined;
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpTRe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpTA = event.value || undefined;
    if (this.dpTR) {
      this.dpTR = this.dpTR
        .add(23, 'hours')
        .add(59, 'minutes')
        .add(59, 'seconds');
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpFPe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpFP = event.value || undefined;
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpTPe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpTP = event.value || undefined;
    if (this.dpTP) {
      this.dpTP = this.dpTP
        .add(23, 'hours')
        .add(59, 'minutes')
        .add(59, 'seconds');
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpFIe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpFI = event.value || undefined;
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpTIe(type: string, event: MatDatepickerInputEvent<any>) {
    //this.dpTI = event.value || undefined;
    if (this.dpTI) {
      this.dpTI = this.dpTI
        .add(23, 'hours')
        .add(59, 'minutes')
        .add(59, 'seconds');
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpFSDe(type: string, event: MatDatepickerInputEvent<any>) {
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpTSDe(type: string, event: MatDatepickerInputEvent<any>) {
    if (this.dpTSD) {
      this.dpTSD = this.dpTSD
        .add(23, 'hours')
        .add(59, 'minutes')
        .add(59, 'seconds');
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpFRDe(type: string, event: MatDatepickerInputEvent<any>) {
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpTRDe(type: string, event: MatDatepickerInputEvent<any>) {
    if (this.dpTRD) {
      this.dpTRD = this.dpTRD
        .add(23, 'hours')
        .add(59, 'minutes')
        .add(59, 'seconds');
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpFADe(type: string, event: MatDatepickerInputEvent<any>) {
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  dpTADe(type: string, event: MatDatepickerInputEvent<any>) {
    if (this.dpTAD) {
      this.dpTAD = this.dpTAD
        .add(23, 'hours')
        .add(59, 'minutes')
        .add(59, 'seconds');
    }
    this.paginator.pageIndex = 0;
    this.loadShipmentsList();
  }

  //End filter shit
  loadShipmentsList() {
    this.selection.clear();
    const queryParams = new QueryParamsModel(
      this.filterConfiguration(),
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize
    );

    if (this.adminView) {
      queryParams.for_staff = true;
    }

    this.store.dispatch(new ShipmentsPageRequested({ page: queryParams }));
    if (this.adminView) {
      this.store.dispatch(new SetFinancialFilters({ filters: queryParams }));
    } else {
      this.store.dispatch(
        new SetUserFinancialFilters({ filters: queryParams })
      );
    }

    this.selection.clear();
  }

  /** FILTRATION */
  filterConfiguration(): any {
    const filter: any = {};

    filter.uids = this.fUsers.map(usr => usr.id);
    filter._ab_uids = this.fabUsers.map(usr => usr.id);
    filter.recipient_name = this.searchInput.nativeElement.value;
    filter.recipient_tel = this.searchInputTel.nativeElement.value;
    filter._status = this.fStatus;
    filter.vg_codes = [...this.fvg_codes];

    if (!this.delivered) {
      filter.is_delivered = false;
    }

    if (this.odelivered) {
      filter.only_delivered = true;
    }

    if (!this.returned) {
      filter.is_returned = false;
    }

    if (this.oreturned) {
      filter.only_returned = true;
    }

    if (this.odsr) {
      filter.odsr = true;
    }

    if (this.arsr) {
      filter.arsr = true;
    }

    if (!this.sprepaid) {
      filter.is_prepaid = false;
    }

    if (this.oprepaid) {
      filter.only_prepaid = true;
    }

    if (this.ord) {
      filter.ord = true;
    }

    if (this.snd_del) {
      filter.snd_del = true;
    }

    if (this.osp) {
      filter.osp = true;
    }

    if (this.nocod) {
      filter.nocod = true;
    }

    if (this.ocod) {
      filter.ocod = true;
    }

    if (this.diffinvw) {
      filter.diffinvw = true;
    }

    if (this.dpFA) {
      filter.dpfa = this.dpFA.format();
    }

    if (this.dpTA) {
      filter.dpta = this.dpTA.format();
    }

    if (this.dpFR) {
      filter.dpfr = this.dpFR.format();
    }

    if (this.dpTR) {
      filter.dptr = this.dpTR.format();
    }

    if (this.dpFP) {
      filter.dpfp = this.dpFP.format();
    }

    if (this.dpTP) {
      filter.dptp = this.dpTP.format();
    }

    if (this.dpFI) {
      filter.dpfi = this.dpFI.format();
    }

    if (this.dpTI) {
      filter.dpti = this.dpTI.format();
    }

    if (this.dpFSD) {
      filter.dpfsd = this.dpFSD.format();
    }

    if (this.dpTSD) {
      filter.dptsd = this.dpTSD.format();
    }

    if (this.dpFRD) {
      filter.dpfrd = this.dpFRD.format();
    }

    if (this.dpTRD) {
      filter.dptrd = this.dpTRD.format();
    }

    if (this.dpFAD) {
      filter.dpfad = this.dpFAD.format();
    }

    if (this.dpTAD) {
      filter.dptad = this.dpTAD.format();
    }

    if (this.courier) {
      filter.courier = this.courier;
    }

    return filter;
  }

  printVoucher(_item: Shipment) {
    this.store.dispatch(new FetchVoucher({ shipment: _item }));
    this.store
      .pipe(
        select(selectShipmentById(_item.id)),
        takeUntil(
          this.actions$.pipe(ofType<GotVoucher>(ShipmentActionTypes.GotVoucher))
        ),
        takeUntil(
          this.actions$.pipe(ofType<ActionFail>(ShipmentActionTypes.ActionFail))
        ),
        last(),
        tap((res: Shipment) => this.actualPrint(res))
      )
      .subscribe();
  }

  printVouchers() {
    const _ids: Array<number> = [];
    this.isPrinting.next(true);

    this.bigBucket.forEach(elem => {
      _ids.push(elem.id);
    });
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    this.http
      .post(
        'api/shipments/mass_print/',
        { ids: _ids },
        { headers: httpHeaders }
      )
      .pipe(
        take(1),
        tap((res: string) => {
          {
            const url = res;
            this.http
              .get(url, {
                headers: new HttpHeaders({
                  'Content-Type': 'application/octet-stream',
                }),
                responseType: 'blob',
              })
              .pipe(
                map(res => {
                  const isFirefox =
                    navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
                  if (isFirefox) {
                    this.pdfViewerOnDemand.pdfSrc = res;
                    this.pdfViewerOnDemand.refresh();
                  } else {
                    const blob = new Blob([res], { type: 'application/pdf' });
                    const blobUrl = URL.createObjectURL(blob);
                    const iframe = document.createElement('iframe');
                    document.body.appendChild(iframe);
                    iframe.src = blobUrl;
                    iframe.style.display = 'none';
                    return iframe;
                  }
                }),
                delay(4000),
                tap(ifr => {
                  if (ifr) {
                    ifr.contentWindow.print();
                  }
                }),
                finalize(() => this.isPrinting.next(false))
              )
              .subscribe();
          }
        })
      )
      .subscribe();
  }

  actualPrint(item: Shipment) {
    if (!this.isPrinting.value) {
      this.isPrinting.next(true);
      const url = `/api/shipments/${item.id}/pdf_raw/`;
      this.http
        .get(url, {
          headers: new HttpHeaders({
            'Content-Type': 'application/octet-stream',
          }),
          responseType: 'blob',
        })
        .pipe(
          map(res => {
            const isFirefox =
              navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            if (isFirefox) {
              this.pdfViewerOnDemand.pdfSrc = res;
              this.pdfViewerOnDemand.refresh();
            } else {
              const blob = new Blob([res], { type: 'application/pdf' });
              const blobUrl = URL.createObjectURL(blob);
              const iframe = document.createElement('iframe');
              document.body.appendChild(iframe);
              iframe.src = blobUrl;
              iframe.style.display = 'none';
              return iframe;
            }
          }),
          delay(4000),
          tap(ifr => {
            if (ifr) {
              ifr.contentWindow.print();
            }
          }),
          finalize(() => this.isPrinting.next(false))
        )
        .subscribe();
    }
  }

  check_kg_s(_item: Shipment) {
    this.store.dispatch(new ShipmentCheckWeight({ shipment: _item }));
  }

  check_kg() {
    const _title = 'Διασταύρωση Βάρους';
    const _description = 'Είστε σίγουρος πως θέλετε να ελεγχθούν οι αποστολές;';
    const _waitDesciption = 'Οι αποστολές ελέγχονται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      const _ids: Array<number> = [];

      this.bigBucket.forEach(elem => {
        _ids.push(elem.id);
      });
      this.store.dispatch(new ShipmentMassCheckWeight({ ids: _ids }));
    });
  }

  markPrepaid(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να μαρκάρετε την αποστολή ως Προπληρωμένη;';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkPrepaid({ shipment: _item }));
    });
  }

  toggleReturnDelivered(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής;';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new ToggleReturnDelivered({ shipment: _item }));
    });
  }

  toggleSendDelivered(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής;';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new ToggleSendDelivered({ shipment: _item }));
    });
  }

  checkReturned(_item: Shipment) {
    this.store.dispatch(new CheckReturned({ shipment: _item }));
    //console.log(_item);
  }

  unmarkPrepaid(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να μαρκάρετε την αποστολή ως μη Προπληρωμένη;';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new UnMarkPrepaid({ shipment: _item }));
    });
  }

  markPrereturn(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να μαρκάρετε την αποστολή ως Προ-Αποδομένη;';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkPrereturn({ shipment: _item }));
    });
  }

  unmarkPrereturn(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να μαρκάρετε την αποστολή ως μη Προ-Αποδομένη;';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new UnMarkPrereturn({ shipment: _item }));
    });
  }

  massMarkPrepaid() {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση των αποστολών σε Προπληρωμένες;';
    const _waitDesciption = 'Οι αποστολές καταχωρούνται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      const _ids: Array<number> = [];

      this.bigBucket.forEach(elem => {
        _ids.push(elem.id);
      });
      this.store.dispatch(new MassMarkPrepaid({ ids: _ids }));
    });
  }

  markReturned(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής σε Επεστραμένη';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkReturned({ shipment: _item }));
    });
  }

  massMarkCancellationPending() {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση των αποστολών σε Προς Ακύρωση;';
    const _waitDesciption = 'Οι αποστολές καταχωρούνται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      const _ids: Array<number> = [];

      this.bigBucket.forEach(elem => {
        _ids.push(elem.id);
      });
      this.store.dispatch(new MassMarkCancellationPending({ ids: _ids }));
    });
  }

  shipmentCancel(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description = 'Είστε σίγουρος πως θέλετε να ακυρώσετε την αποστολή;';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new ShipmentCancel({ shipment: _item }));
    });
  }

  markPaid_s(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής σε Εισπραγμένη';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkPaid({ shipment: _item }));
    });
  }

  markClarification(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής σε Προς Διασάφηση';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkClarification({ shipment: _item }));
    });
  }

  markCancellationPending(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής σε Προς Ακύρωση';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkCancellationPending({ shipment: _item }));
    });
  }

  markPaidApproved_s(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής σε Προς Απόδοση';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkPaidApproved({ shipment: _item }));
    });
  }

  markInvoiced_s(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής σε Εξοφλημένη';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkInvoiced({ shipment: _item }));
    });
  }

  markProcessed_s(_item: Shipment) {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση της αποστολής σε Εγκεκριμένη';
    const _waitDesciption = 'Η αλλαγή καταχωρείται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.store.dispatch(new MarkProcessed({ shipment: _item }));
    });
  }

  markPaid() {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση των αποστολών σε Εισπράχτηκε;';
    const _waitDesciption = 'Οι αποστολές καταχωρούνται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      const _ids: Array<number> = [];

      this.bigBucket.forEach(elem => {
        _ids.push(elem.id);
      });
      this.store.dispatch(new MassMarkPaid({ ids: _ids }));
    });
  }

  markPaidApproved() {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση των αποστολών σε Προς Απόδοση;';
    const _waitDesciption = 'Οι αποστολές καταχωρούνται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      const _ids: Array<number> = [];

      this.bigBucket.forEach(elem => {
        _ids.push(elem.id);
      });
      this.store.dispatch(new MassMarkPaidApproved({ ids: _ids }));
    });
  }

  markInvoiced() {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση των αποστολών σε Εξοφλημένη;';
    const _waitDesciption = 'Οι αποστολές καταχωρούνται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      const _ids: Array<number> = [];

      this.bigBucket.forEach(elem => {
        _ids.push(elem.id);
      });
      this.store.dispatch(new MassMarkInvoiced({ ids: _ids }));
    });
  }

  markProcessed() {
    const _title = 'Αλλαγή Κατάστασης';
    const _description =
      'Είστε σίγουρος πως θέλετε να αλλάξετε την κατάσταση των αποστολών σε Εγκρίθηκε;';
    const _waitDesciption = 'Οι αποστολές καταχωρούνται';

    const dialogRef = this.layoutUtilsService.approveElement(
      _title,
      _description,
      _waitDesciption
    );
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      const _ids: Array<number> = [];

      this.bigBucket.forEach(elem => {
        _ids.push(elem.id);
      });
      this.store.dispatch(new MassMarkProcessed({ ids: _ids }));
    });
  }

  viewShipment(item: Shipment) {
    this.layoutUtilsService.viewShipment({
      item: item,
      adm: this.adminView,
      financial: true,
    });
  }

  viewShipmentTracking(item: Shipment) {
    this.layoutUtilsService.viewShipment({
      item: item,
      adm: this.adminView,
      financial: false,
    });
  }

  viewVoucher(_item: Shipment) {
    this.store.dispatch(new FetchVoucher({ shipment: _item }));
    this.store
      .pipe(
        select(selectShipmentById(_item.id)),
        takeUntil(
          this.actions$.pipe(ofType<GotVoucher>(ShipmentActionTypes.GotVoucher))
        ),
        takeUntil(
          this.actions$.pipe(ofType<ActionFail>(ShipmentActionTypes.ActionFail))
        ),
        last(),
        tap((res: Shipment) =>
          this.layoutUtilsService.viewVoucher({ item: res })
        )
      )
      .subscribe();
  }

  onFileSelected(event) {
    const inputNode: any = document.querySelector('#file');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });
        const refined: Array<any> = [];
        res.forEach(k =>
          refined.push({
            vg_code: '' + Object.values(k)[0],
            cod_ammount: parseFloat('' + Object.values(k)[1]),
          })
        );
        //var nng:number = refined.filter( (k:any) => !(''+k.vg_code).startsWith("NG") ).length;
        //if(nng) {
        //    this.customWarning.next(`Βρέθηκαν ${nng} αποστολές με μη συμβατό κωδικό αποστολής ( κωδ. αποστολής που δεν ξεκινάει απο 'NG' ).`);
        //}
        //refined = refined.filter( (k:any) => (''+k.vg_code).startsWith("NG") );
        this.store.dispatch(new MarkAsPaidByXLS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onFileSelectedElta2(event) {
    const inputNode: any = document.querySelector('#file_elta2');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });
        const refined: Array<any> = [];
        res.forEach(k =>
          refined.push({
            vg_code: '' + Object.values(k)[0],
            cod_ammount: parseFloat('' + Object.values(k)[1]),
          })
        );
        //var nng:number = refined.filter( (k:any) => !(''+k.vg_code).startsWith("NG") ).length;
        //if(nng) {
        //    this.customWarning.next(`Βρέθηκαν ${nng} αποστολές με μη συμβατό κωδικό αποστολής ( κωδ. αποστολής που δεν ξεκινάει απο 'NG' ).`);
        //}
        //refined = refined.filter( (k:any) => (''+k.vg_code).startsWith("NG") );
        this.store.dispatch(new MarkAsPaidByXLS_ELTA2({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onCSPaidSelected(event) {
    const inputNode: any = document.querySelector('#file_cs');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });

        let vgCol: any;
        let codCol: any;
        let manifestCol: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && codCol && manifestCol) {
            if (e[vgCol] && e[codCol] && e[manifestCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                cod_ammount: parseFloat('' + e[codCol]),
              });
            }
          }

          const vals = Object.values(e);
          if (
            vals.includes('Αποδεικτικό Αποστολής') &&
            vals.includes('Ποσό') &&
            vals.includes('Αρ.Μανιφέστου')
          ) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αποδεικτικό Αποστολής') {
                vgCol = key;
              }
              if (value === 'Ποσό') {
                codCol = key;
              }
              if (value === 'Αρ.Μανιφέστου') {
                manifestCol = key;
              }
            }
          }
        });
        this.store.dispatch(new MarkAsPaidByXLS_CS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onSPDXPaidSelected(event) {
    const inputNode: any = document.querySelector('#file_spdx');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });

        let vgCol: any;
        let codCol: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && codCol) {
            if (e[vgCol] && e[codCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                cod_ammount: parseFloat('' + e[codCol]),
              });
            }
          }

          const vals = Object.values(e);
          if (
            vals.includes('Αριθμός Αποστολής') &&
            vals.includes('Ποσό Αντικαταβολής')
          ) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αριθμός Αποστολής') {
                vgCol = key;
              }
              if (value === 'Ποσό Αντικαταβολής') {
                codCol = key;
              }
            }
          }
        });
        this.store.dispatch(new MarkAsPaidByXLS_SPDX({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onGenikiPaidSelected(event) {
    const inputNode: any = document.querySelector('#file_geniki');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });

        let vgCol: any;
        let codCol: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && codCol) {
            if (e[vgCol] && e[codCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                cod_ammount: parseFloat('' + e[codCol]),
              });
            }
          }

          const vals = Object.values(e);
          if (vals.includes('Αποδεικτικό') && vals.includes('Ποσό')) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αποδεικτικό') {
                vgCol = key;
              }
              if (value === 'Ποσό') {
                codCol = key;
              }
            }
          }
        });
        //console.log(refined);
        this.store.dispatch(new MarkAsPaidByXLS_GENIKI({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onGenikiApprovedSelected(event) {
    const inputNode: any = document.querySelector('#file_geniki_app');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });

        let vgCol: any;
        let idCol: any;

        let refined: Array<any> = [];
        const regExp = /\(([^)]+)\)/;

        res.forEach(e => {
          if (vgCol && idCol) {
            if (e[vgCol] && e[idCol]) {
              const parsed = regExp.exec(e[idCol]);
              if (parsed && parsed.length > 1) {
                refined.push({
                  vg_code: '' + e[vgCol].replace(' ', ''),
                  id: parsed[1],
                });
              }
            }
          }

          const vals = Object.values(e);
          if (
            vals.includes('ΑΡΙΘΜΟΣ ΑΠΟΣΤΟΛΗΣ') &&
            vals.includes('ΠΑΡΑΤΗΡΗΣΕΙΣ')
          ) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'ΑΡΙΘΜΟΣ ΑΠΟΣΤΟΛΗΣ') {
                vgCol = key;
              }
              if (value === 'ΠΑΡΑΤΗΡΗΣΕΙΣ') {
                idCol = key;
              }
            }
          }
        });
        // remove whatever doesn't start with 4 from refined
        refined = refined.filter((k: any) => ('' + k.vg_code).startsWith('4'));
        //console.log(refined);
        this.store.dispatch(new MarkAsApprovedByXLS_GENIKI({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onTaxyPaidSelected(event) {
    const inputNode: any = document.querySelector('#file_taxy');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });

        let vgCol: any;
        let codCol: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && codCol) {
            if (e[vgCol] && e[codCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                cod_ammount: parseFloat('' + e[codCol]),
              });
            }
          }

          const vals = Object.values(e);
          if (
            vals.includes('Αποδεικτικό Αποστολής') &&
            vals.includes('Ποσό Αντικαταβολής')
          ) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αποδεικτικό Αποστολής') {
                vgCol = key;
              }
              if (value === 'Ποσό Αντικαταβολής') {
                codCol = key;
              }
            }
          }
        });

        this.store.dispatch(new MarkAsPaidByXLS_TAXY({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onACSPaidSelected(event) {
    const inputNode: any = document.querySelector('#file_acs');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });

        let vgCol: any;
        let codCol: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && codCol) {
            if (e[vgCol] && e[codCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                cod_ammount: parseFloat('' + e[codCol]),
              });
            }
          }

          const vals = Object.values(e);
          if (vals.includes('Αποδεικτικό') && vals.includes('Ποσό')) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αποδεικτικό') {
                vgCol = key;
              }
              if (value === 'Ποσό') {
                codCol = key;
              }
            }
          }
        });

        this.store.dispatch(new MarkAsPaidByXLS_ACS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onACSCheckSelected($event) {
    const inputNode: any = document.querySelector('#file_acs_check');
    const file: File = $event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });
        console.log(res);
        let vgCol: any;
        let w1Col: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && w1Col) {
            if (e[vgCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                w1: parseFloat('' + parseFloat('' + e[w1Col]).toFixed(2)),
              });
            }
          }

          const vals = Object.values(e);
          if (vals.includes('Αριθμός Αποδεικτικού') && vals.includes('Βάρος')) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αριθμός Αποδεικτικού') {
                vgCol = key;
              }
              if (value === 'Βάρος') {
                w1Col = key;
              }
            }
          }
        });

        this.store.dispatch(new CheckKgByXLS_ACS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onCkeckKgSelected(event) {
    const inputNode: any = document.querySelector('#file_check_kg');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });
        let vgCol: any;
        let w1Col: any;
        let w2Col: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && w1Col && w2Col) {
            if (e[vgCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                w1: parseFloat('' + parseFloat('' + e[w1Col]).toFixed(2)),
                w2: parseFloat('' + parseFloat('' + e[w2Col]).toFixed(2)),
              });
            }
          }

          const vals = Object.values(e);
          if (vals.includes('Αριθμός φορτωτικής') && vals.includes('Βάρος')) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αριθμός φορτωτικής') {
                vgCol = key;
              }
              if (value === 'Βάρος' && !w1Col) {
                w1Col = key;
              }
              if (value === 'Βάρος' && w1Col) {
                w2Col = key;
              }
            }
          }
        });
        this.store.dispatch(new CheckKgByXLS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onXLSSearchSelected(event) {
    const inputNode: any = document.querySelector('#file_search');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });
        let vgCol: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol) {
            if (e[vgCol]) {
              refined.push({ vg_code: '' + e[vgCol].replace(/\s/g, '') });
            }
          }

          const vals = Object.values(e);
          for (const [key, value] of Object.entries(e)) {
            if (('' + value).includes('ΣΥΔΕΤΑ')) {
              vgCol = key;
            }
          }
        });
        console.log(refined);
        const codes: Array<string> = [];
        refined.forEach(sh => codes.push(sh.vg_code));

        this.fvg_codes = [...codes];
        this.refs();
        //this.store.dispatch(new ValidateSPDX({items: refined}));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onSPDXValidateSelected(event) {
    const inputNode: any = document.querySelector('#file_spdx_validate');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });
        let vgCol: any;
        let wCol: any;

        const refined: Array<any> = [];
        res.forEach(e => {
          if (vgCol && wCol) {
            if (e[vgCol] && e[wCol]) {
              refined.push({
                vg_code: '' + e[vgCol],
                weight: parseFloat('' + e[wCol]),
              });
            }
          }

          const vals = Object.values(e);
          if (vals.includes('Αριθμός Αποστολής') && vals.includes('Βάρος')) {
            for (const [key, value] of Object.entries(e)) {
              if (value === 'Αριθμός Αποστολής') {
                vgCol = key;
              }
              if (value === 'Βάρος') {
                wCol = key;
              }
            }
          }
        });
        this.store.dispatch(new ValidateSPDX({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onSendDeliveredSelected(event) {
    const inputNode: any = document.querySelector('#file_send_delivered');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });
        const refined: Array<any> = [];
        res.forEach(k =>
          refined.push({
            vg_code: '' + Object.values(k)[0],
            weight: Object.values(k)[1]
              ? parseFloat('' + Object.values(k)[1])
              : undefined,
          })
        );
        //console.log(refined);
        this.store.dispatch(new SendDeliveredXLS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  onReturnDeliveredSelected(event) {
    const inputNode: any = document.querySelector('#file_return_delivered');
    const file: File = event.target.files[0];

    import('xlsx').then(XLSX => {
      const fileReader = new FileReader();
      fileReader.onload = e => {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const workbook: import('xlsx').WorkBook = XLSX.read(data, {
          type: 'array',
        });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        const res: Array<any> = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          header: 'A',
        });

        const refined: Array<any> = [];
        res.forEach(k => {
          if (Object.values(k)[1] && Object.values(k)[2]) {
            refined.push({
              vg_code: '' + Object.values(k)[0],
              kap: '' + Object.values(k)[1],
              weight: parseFloat(
                '' + parseFloat('' + Object.values(k)[2]).toFixed(2)
              ),
            });
          } else {
            refined.push({ vg_code: '' + Object.values(k)[0] });
          }
        });
        //console.log(refined);
        this.store.dispatch(new ReturnDeliveredXLS({ items: refined }));
      };
      fileReader.readAsArrayBuffer(file);
    });
  }

  createCodXLS(return_f = false): any {
    return import('xlsx').then(XLSX => {
      // eslint-disable-next-line @typescript-eslint/ban-types
      const data: Array<Object> = [];
      let sum = 0;
      const ids: Array<number> = [];
      this.bigBucket
        .filter(row => row._status === 'PAID_APPROVED')
        .filter(row => row.is_cod)
        .filter(row => parseFloat('' + row.cod_ammount) != 0)
        .forEach(elem => {
          ids.push(elem.id);
          const o: { [k: string]: any } = {};
          o['Όνομα Παραλήπτη'] = elem.recipient_name;
          o['Κωδικός Αποστολής'] = elem.vg_code;
          o['Ποσό Αντικαταβολής'] = parseFloat(
            '' + (elem.cod_ammount || 0)
          ).toFixed(2);
          if (elem.is_prereturn) {
            o['Αποδοτέο'] = parseFloat(
              '' +
                ((parseFloat('' + elem.cod_ammount) || 0) -
                  (parseFloat('' + elem.prereturn_ammount) || 0))
            ).toFixed(2);
            sum += parseFloat(
              parseFloat('' + (elem.cod_ammount || 0)).toFixed(2)
            );
            sum -= parseFloat(
              parseFloat('' + (elem.prereturn_ammount || 0)).toFixed(2)
            );
          } else {
            o['Αποδοτέο'] = parseFloat(
              '' + (parseFloat('' + elem.cod_ammount) || 0)
            ).toFixed(2);
            sum += parseFloat(
              parseFloat('' + (elem.cod_ammount || 0)).toFixed(2)
            );
          }
          o['Ημερομηνία Έγκρισης'] = elem.date_approved
            ? this.dp.transform(elem.date_approved, 'dd/MM/yyyy')
            : '';
          this.store
            .pipe(
              select(selectUserById(elem.user)),
              take(1),
              tap(res => {
                o['Όνομα Παραλήπτη'] = `${res.id} ${o['Όνομα Παραλήπτη']}`;
              })
            )
            .subscribe();
          data.push(o);
        });
      this.bigBucket
        .filter(row => row._status === 'RETURNED' && row.is_prereturn)
        .filter(row => row.is_cod)
        .filter(row => parseFloat('' + row.cod_ammount) != 0)
        .forEach(elem => {
          ids.push(elem.id);
          const o: { [k: string]: any } = {};
          o['Όνομα Παραλήπτη'] = elem.recipient_name;
          o['Κωδικός Αποστολής'] = elem.vg_code;
          o['Ποσό Αντικαταβολής'] = parseFloat(
            '' + (elem.cod_ammount || 0)
          ).toFixed(2);
          o['Αποδοτέο'] = parseFloat(
            '' + (-1 * parseFloat('' + elem.prereturn_ammount) || 0)
          ).toFixed(2);
          sum -= parseFloat(
            parseFloat('' + (elem.prereturn_ammount || 0)).toFixed(2)
          );
          o['Ημερομηνία Έγκρισης'] = elem.date_approved
            ? this.dp.transform(elem.date_approved, 'dd/MM/yyyy')
            : '';
          this.store
            .pipe(
              select(selectUserById(elem.user)),
              take(1),
              tap(res => {
                o['Όνομα Παραλήπτη'] = `${res.id} ${o['Όνομα Παραλήπτη']}`;
              })
            )
            .subscribe();
          data.push(o);
        });
      if (this.bigBucket.length > 0) {
        this.store
          .pipe(
            select(selectUserById(this.bigBucket[0].user)),
            take(1),
            tap(res => {
              if (res.allow_prereturns) {
                this.bigBucket
                  .filter(row => row._status === 'PROCESSED')
                  .filter(row => row.is_cod)
                  .filter(row => parseFloat('' + row.cod_ammount) != 0)
                  .filter(row => !row.is_prereturn)
                  .filter(row => row.is_delivered)
                  .forEach(elem => {
                    ids.push(elem.id);
                    const o: { [k: string]: any } = {};
                    o['Όνομα Παραλήπτη'] = elem.recipient_name;
                    o['Κωδικός Αποστολής'] = elem.vg_code;
                    o['Ποσό Αντικαταβολής'] = parseFloat(
                      '' + (elem.cod_ammount || 0)
                    ).toFixed(2);
                    let tmp_ammount =
                      (parseFloat(
                        parseFloat('' + (elem.cod_ammount || 0)).toFixed(2)
                      ) *
                        parseFloat('' + res.prereturn_perc)) /
                      100;
                    tmp_ammount = parseFloat(tmp_ammount.toFixed(2));
                    o['Αποδοτέο'] = parseFloat(
                      '' +
                        (tmp_ammount > parseFloat('' + res.prereturn_max)
                          ? parseFloat('' + res.prereturn_max)
                          : tmp_ammount)
                    ).toFixed(2);
                    sum +=
                      tmp_ammount > parseFloat('' + res.prereturn_max)
                        ? parseFloat('' + res.prereturn_max)
                        : tmp_ammount;
                    o['Ημερομηνία Έγκρισης'] = elem.date_approved
                      ? this.dp.transform(elem.date_approved, 'dd/MM/yyyy')
                      : '';
                    o['Όνομα Παραλήπτη'] = `${res.id} ${o['Όνομα Παραλήπτη']}`;
                    data.push(o);
                  });
              }
            })
          )
          .subscribe();
      }
      /* eslint-disable */
      data.push({
        'Όνομα Παραλήπτη': undefined,
        'Κωδικός Αποστολής': undefined,
        'Ποσό Αντικαταβολής': undefined,
        'Αποδοτέο': undefined,
        'Ημερομηνία Έγκρισης': undefined,
      });
      data.push({
        'Όνομα Παραλήπτη': undefined,
        'Κωδικός Αποστολής': 'Σύνολο',
        'Ποσό Αντικαταβολής': undefined,
        'Αποδοτέο': parseFloat('' + sum).toFixed(2),
        'Ημερομηνία Έγκρισης': undefined,
      });
      /* eslint-enable */
      const workSheet = XLSX.utils.json_to_sheet(data);
      const workBook: import('xlsx').WorkBook = XLSX.utils.book_new();
      const wscols = [
        { width: 40 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
      ];
      workSheet['!cols'] = wscols;
      XLSX.utils.book_append_sheet(workBook, workSheet, 'Αποστολές');
      if (return_f) {
        const wbout = XLSX.write(workBook, {
          bookType: 'xlsx',
          bookSST: false,
          type: 'binary',
        });
        const bdata = new Blob([this.s2ab(wbout)], {
          type: 'application/octet-stream',
        });
        return {
          file: new File([bdata], 'cod_xls.xlsx', {
            type: 'application/octet-stream',
            lastModified: Date.now(),
          }),
          ids: ids,
        };
      } else {
        const user = this.fUsers[0];
        XLSX.writeFile(
          workBook,
          `${user.id}_${user.kap} ΑΠΟΔΟΣΗ ΑΝΤΙΚΑΤΑΒΟΛΩΝ ${this.dp.transform(
            Date.now(),
            'dd-MM-yyyy'
          )}.xlsx`
        );
      }
    });
  }

  createChargesXLS(return_f = false): any {
    return import('xlsx').then(XLSX => {
      // eslint-disable-next-line @typescript-eslint/ban-types
      const data: Array<Object> = [];
      let sum = 0;
      const ids: Array<number> = [];

      //Take care of all shipments that need only prereturn charge first
      const tuid: number = this.fUsers[0].id;
      this.store
        .pipe(
          select(selectUserById(tuid)),
          take(1),
          tap(tusr => {
            if (tusr.allow_prereturns) {
              this.bigBucket
                .filter(row => row._status === 'PROCESSED')
                .filter((row: any) => {
                  return (
                    row.is_prepaid === true &&
                    row.is_delivered === true &&
                    row.is_prereturn === false
                  );
                })
                .forEach((elem: any) => {
                  ids.push(elem.id);
                  const o: { [k: string]: any } = {};
                  o['Όνομα Παραλήπτη'] = elem.recipient_name;
                  o['Διεύθυνση Παραλήπτη'] = elem.recipient_address;
                  o['Τηλέφωνο Παραλήπτη'] = elem.recipient_phone;
                  o['TK Παραλήπτη'] = elem.recipient_postcode;
                  o['Αποστολέας'] =
                    tusr.id + ' ' + tusr.lastname + ' ' + tusr.firstname;
                  o['Όνομα Παραλήπτη'] = `${tusr.id} ${o['Όνομα Παραλήπτη']}`;
                  o['Ποσό Αντικαταβολής'] = elem.cod_ammount || 0;
                  o['Κωδικός Αποστολής'] = elem.vg_code;
                  o['Κωδικός Επιστροφής'] = elem.vg_code_return;
                  o['Βάρος'] = elem.weight;
                  o['Τεμάχια'] = elem.items;
                  o['Πάγιο'] = undefined;
                  o['Αντικαταβολή'] = undefined;
                  o['Υπέρβαρο'] = undefined;
                  o['Επιπλέον Χρεώσεις'] = parseFloat(
                    parseFloat('' + tusr.prereturn_charge).toFixed(2)
                  );
                  o['Αξία'] = parseFloat(
                    parseFloat('' + tusr.prereturn_charge).toFixed(2)
                  );
                  o['Σύνολο'] =
                    parseFloat(
                      parseFloat('' + tusr.prereturn_charge).toFixed(2)
                    ) *
                    (1 + tusr.vat_val / 100);
                  sum +=
                    parseFloat(
                      parseFloat('' + tusr.prereturn_charge).toFixed(2)
                    ) *
                    (1 + tusr.vat_val / 100);
                  data.push(o);
                });
            }
          })
        )
        .subscribe();

      //Now take care of the rest
      this.bigBucket
        .filter(
          row =>
            row._status === 'PAID_APPROVED' ||
            row._status === 'PROCESSED' ||
            row._status === 'RETURNED'
        )
        .filter((row: any) => {
          return (
            row.is_prepaid === false ||
            (row.is_prepaid &&
              parseFloat(row.cost).toFixed(2) !==
                parseFloat(row.prepaid_ammount).toFixed(2) &&
              row.prepaid_ammount &&
              row._status !== 'PROCESSED')
          );
        })
        .forEach((elem: any) => {
          ids.push(elem.id);
          const o: { [k: string]: any } = {};
          o['Όνομα Παραλήπτη'] = elem.recipient_name;
          o['Διεύθυνση Παραλήπτη'] = elem.recipient_address;
          o['Τηλέφωνο Παραλήπτη'] = elem.recipient_phone;
          o['TK Παραλήπτη'] = elem.recipient_postcode;
          this.store
            .pipe(
              select(selectUserById(elem.user)),
              take(1),
              tap(res => {
                o['Αποστολέας'] =
                  res.id + ' ' + res.lastname + ' ' + res.firstname;
                o['Όνομα Παραλήπτη'] = `${res.id} ${o['Όνομα Παραλήπτη']}`;
              })
            )
            .subscribe();
          //o['Αποστολέας'] = elem.user;
          o['Ποσό Αντικαταβολής'] = elem.cod_ammount || 0;
          o['Κωδικός Αποστολής'] = elem.vg_code;
          o['Κωδικός Επιστροφής'] = elem.vg_code_return;
          o['Βάρος'] = elem.weight;
          o['Τεμάχια'] = elem.items;
          o['Πάγιο'] = parseFloat(parseFloat(elem.basec).toFixed(2));
          o['Αντικαταβολή'] = parseFloat(parseFloat(elem.codc).toFixed(2));
          o['Υπέρβαρο'] = parseFloat(parseFloat(elem.ekgc).toFixed(2));
          if (
            elem.is_prepaid &&
            parseFloat(elem.cost).toFixed(2) !==
              parseFloat(elem.prepaid_ammount).toFixed(2) &&
            elem.prepaid_ammount
          ) {
            let pawo_vat = parseFloat(
              parseFloat(elem.prepaid_ammount).toFixed(2)
            );
            if (parseFloat(elem.vat) > 0) {
              pawo_vat =
                parseFloat(parseFloat(elem.prepaid_ammount).toFixed(2)) /
                (1 + parseFloat(elem.vat) / 100);
              pawo_vat = parseFloat(pawo_vat.toFixed(2));
            }
            o['Επιπλέον Χρεώσεις'] =
              parseFloat(parseFloat(elem.ec).toFixed(2)) - pawo_vat;
            o['Αξία'] = parseFloat(parseFloat(elem.pvat).toFixed(2)) - pawo_vat;
            o['Σύνολο'] =
              parseFloat(parseFloat(elem.cost).toFixed(2)) -
              parseFloat(parseFloat(elem.prepaid_ammount || 0).toFixed(2));
            sum += parseFloat(parseFloat(elem.cost || 0).toFixed(2));
            sum -= parseFloat(parseFloat(elem.prepaid_ammount || 0).toFixed(2));
          } else {
            o['Επιπλέον Χρεώσεις'] = parseFloat(parseFloat(elem.ec).toFixed(2));
            o['Αξία'] = parseFloat(parseFloat(elem.pvat).toFixed(2));
            o['Σύνολο'] = parseFloat(parseFloat(elem.cost).toFixed(2));
            sum += parseFloat(parseFloat(elem.cost || 0).toFixed(2));

            this.store
              .pipe(
                select(selectUserById(elem.user)),
                take(1),
                tap(res => {
                  if (
                    res.allow_prereturns &&
                    elem._status === 'PROCESSED' &&
                    elem.is_cod &&
                    parseFloat('' + elem.cod_ammount) > 0 &&
                    elem.is_delivered &&
                    !elem.is_prereturn
                  ) {
                    o['Επιπλέον Χρεώσεις'] += parseFloat(
                      parseFloat('' + res.prereturn_charge).toFixed(2)
                    );
                    o['Αξία'] += parseFloat(
                      parseFloat('' + res.prereturn_charge).toFixed(2)
                    );
                    o['Σύνολο'] +=
                      parseFloat(
                        parseFloat('' + res.prereturn_charge).toFixed(2)
                      ) *
                      (1 + res.vat_val / 100);
                    sum +=
                      parseFloat(
                        parseFloat('' + res.prereturn_charge).toFixed(2)
                      ) *
                      (1 + res.vat_val / 100);
                  }
                })
              )
              .subscribe();
          }
          data.push(o);
        });
      /* eslint-disable */
      data.push({
        'Όνομα Παραλήπτη': undefined,
        'Διεύθυνση Παραλήπτη': undefined,
        'Τηλέφωνο Παραλήπτη': undefined,
        'TK Παραλήπτη': undefined,
        'Αποστολέας': undefined,
        'Ποσό Αντικαταβολής': undefined,
        'Κωδικός Αποστολής': undefined,
        'Κωδικός Επιστροφής': undefined,
        'Βάρος': undefined,
        'Τεμάχια': undefined,
        'Πάγιο': undefined,
        'Αντικαταβολή': undefined,
        'Υπέρβαρο': undefined,
        'Επιπλέον Χρεώσεις': undefined,
        'Αξία': undefined,
        'Σύνολο': undefined,
      });
      /* eslint-enable */
      this.extraCharges.forEach((elem: any) => {
        const o: { [k: string]: any } = {};
        o['Όνομα Παραλήπτη'] = 'Επιπλέον Χρέωση/Επιστροφή';
        o['Διεύθυνση Παραλήπτη'] = 'Αιτιολογία:';
        o['Τηλέφωνο Παραλήπτη'] = elem.reason;
        o['TK Παραλήπτη'] = undefined;
        o['Αποστολέας'] = undefined;
        o['Ποσό Αντικαταβολής'] = undefined;
        o['Κωδικός Αποστολής'] = undefined;
        o['Κωδικός Επιστροφής'] = undefined;
        o['Βάρος'] = undefined;
        o['Τεμάχια'] = undefined;
        o['Πάγιο'] = undefined;
        o['Αντικαταβολή'] = undefined;
        o['Υπέρβαρο'] = undefined;
        o['Επιπλέον Χρεώσεις'] = undefined;
        o['Αξία'] = undefined;
        o['Σύνολο'] = parseFloat(parseFloat(elem.charge).toFixed(2));
        sum += parseFloat(parseFloat(elem.charge || 0).toFixed(2));
        data.push(o);
      });
      /* eslint-disable */
      data.push({
        'Όνομα Παραλήπτη': undefined,
        'Διεύθυνση Παραλήπτη': undefined,
        'Τηλέφωνο Παραλήπτη': undefined,
        'TK Παραλήπτη': undefined,
        'Αποστολέας': undefined,
        'Ποσό Αντικαταβολής': undefined,
        'Κωδικός Αποστολής': undefined,
        'Κωδικός Επιστροφής': undefined,
        'Βάρος': undefined,
        'Τεμάχια': undefined,
        'Πάγιο': undefined,
        'Αντικαταβολή': undefined,
        'Υπέρβαρο': undefined,
        'Επιπλέον Χρεώσεις': undefined,
        'Αξία': undefined,
        'Σύνολο': undefined,
      });
      data.push({
        'Όνομα Παραλήπτη': undefined,
        'Διεύθυνση Παραλήπτη': undefined,
        'Τηλέφωνο Παραλήπτη': undefined,
        'TK Παραλήπτη': undefined,
        'Αποστολέας': undefined,
        'Ποσό Αντικαταβολής': undefined,
        'Κωδικός Αποστολής': undefined,
        'Κωδικός Επιστροφής': undefined,
        'Βάρος': undefined,
        'Τεμάχια': undefined,
        'Πάγιο': undefined,
        'Αντικαταβολή': undefined,
        'Υπέρβαρο': undefined,
        'Επιπλέον Χρεώσεις': undefined,
        'Αξία': 'Σύνολο',
        'Σύνολο': sum,
      });
      /* eslint-enable */
      const workSheet = XLSX.utils.json_to_sheet(data);
      const workBook: import('xlsx').WorkBook = XLSX.utils.book_new();
      const wscols = [
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 7 },
        { width: 20 },
        { width: 7 },
        { width: 20 },
        { width: 20 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
      ];
      workSheet['!cols'] = wscols;
      XLSX.utils.book_append_sheet(workBook, workSheet, 'Αποστολές');
      if (return_f) {
        const wbout = XLSX.write(workBook, {
          bookType: 'xlsx',
          bookSST: false,
          type: 'binary',
        });
        const bdata = new Blob([this.s2ab(wbout)], {
          type: 'application/octet-stream',
        });
        return {
          file: new File([bdata], 'charges_xls.xlsx', {
            type: 'application/octet-stream',
            lastModified: Date.now(),
          }),
          ids: ids,
        };
      } else {
        const user = this.fUsers[0];
        XLSX.writeFile(
          workBook,
          `${user.id}_${user.kap} ΑΝΑΛΥΣΗ ΧΡΕΩΣΕΩΝ ${this.dp.transform(
            Date.now(),
            'dd-MM-yyyy'
          )}.xlsx`
        );
      }
    });
  }

  genXLS() {
    import('xlsx').then(XLSX => {
      // eslint-disable-next-line @typescript-eslint/ban-types
      const data: Array<Object> = [];
      let sum = 0;

      this.bigBucket.forEach((elem: any) => {
        const o: { [k: string]: any } = {};
        o['ID Πελάτη'] = undefined;
        o['Όνομα Παραλήπτη'] = elem.recipient_name;
        o['Διεύθυνση Παραλήπτη'] = elem.recipient_address;
        o['Περιοχή Παραλήπτη'] = elem.recipient_selected_area
          ? elem.recipient_selected_area.name +
            ' ' +
            elem.recipient_selected_area.nomos
          : elem.recipient_area;
        o['Τηλέφωνο Παραλήπτη'] = elem.recipient_phone;
        o['TK Παραλήπτη'] = elem.recipient_postcode;
        o['Παρατηρήσεις'] = elem.user_comments
          ? `(${elem.id}) ${elem.user_comments}`
          : `(${elem.id})`;
        o['Ημερομηνία Έγκρισης'] = elem.date_approved
          ? this.dp.transform(elem.date_approved, 'dd/MM/yyyy')
          : '';
        o['Ημερομηνία Παράδοσης'] = elem.date_delivered
          ? this.dp.transform(elem.date_delivered, 'dd/MM/yyyy')
          : '';
        this.store
          .pipe(
            select(selectUserById(elem.user)),
            take(1),
            tap(res => {
              o['Αποστολέας'] =
                res.id + ' ' + res.lastname + ' ' + res.firstname;
              o['Όνομα Παραλήπτη'] = `${res.id} ${o['Όνομα Παραλήπτη']}`;
              o['ID Πελάτη'] = res.id;
            })
          )
          .subscribe();
        //o['Αποστολέας'] = elem.user;
        o['Ποσό Αντικαταβολής'] = elem.cod_ammount || 0;
        o['Αμ.Απ.'] = elem.prereturn_ammount || 0;
        o['Κωδικός Αποστολής'] = elem.vg_code;
        o['Κωδικός Επιστροφής'] = elem.vg_code_return;
        o['Τιμολ. Βάρος'] = elem.spdx_validated_weight;
        o['Βάρος'] = elem.weight;
        o['Τεμάχια'] = elem.items;
        o['Πάγιο'] = parseFloat(parseFloat(elem.basec).toFixed(2));
        o['Αντικαταβολή'] = parseFloat(parseFloat(elem.codc).toFixed(2));
        o['Υπέρβαρο'] = parseFloat(parseFloat(elem.ekgc).toFixed(2));
        o['Επιπλέον Χρεώσεις'] = parseFloat(parseFloat(elem.ec).toFixed(2));
        o['Αξία'] = parseFloat(parseFloat(elem.pvat).toFixed(2));
        o['Σύνολο'] = parseFloat(parseFloat(elem.cost).toFixed(2));
        sum += parseFloat(parseFloat(elem.cost || 0).toFixed(2));
        data.push(o);
      });
      /* eslint-disable */
      data.push({
        'ID Πελάτη': undefined,
        'Όνομα Παραλήπτη': undefined,
        'Διεύθυνση Παραλήπτη': undefined,
        'Περιοχή Παραλήπτη': undefined,
        'Τηλέφωνο Παραλήπτη': undefined,
        'TK Παραλήπτη': undefined,
        'Παρατηρήσεις': undefined,
        'Αποστολέας': undefined,
        'Ποσό Αντικαταβολής': undefined,
        'Αμ.Απ.': undefined,
        'Κωδικός Αποστολής': undefined,
        'Κωδικός Επιστροφής': undefined,
        'Τιμολ. Βάρος': undefined,
        'Βάρος': undefined,
        'Τεμάχια': undefined,
        'Πάγιο': undefined,
        'Αντικαταβολή': undefined,
        'Υπέρβαρο': undefined,
        'Επιπλέον Χρεώσεις': undefined,
        'Αξία': undefined,
        'Σύνολο': undefined,
      });
      data.push({
        'ID Πελάτη': undefined,
        'Όνομα Παραλήπτη': undefined,
        'Διεύθυνση Παραλήπτη': undefined,
        'Περιοχή Παραλήπτη': undefined,
        'Τηλέφωνο Παραλήπτη': undefined,
        'TK Παραλήπτη': undefined,
        'Παρατηρήσεις': undefined,
        'Αποστολέας': undefined,
        'Ποσό Αντικαταβολής': undefined,
        'Αμ.Απ.': undefined,
        'Κωδικός Αποστολής': undefined,
        'Κωδικός Επιστροφής': undefined,
        'Τιμολ. Βάρος': undefined,
        'Βάρος': undefined,
        'Τεμάχια': undefined,
        'Πάγιο': undefined,
        'Αντικαταβολή': undefined,
        'Υπέρβαρο': undefined,
        'Επιπλέον Χρεώσεις': undefined,
        'Αξία': 'Σύνολο',
        'Σύνολο': sum,
      });
      /* eslint-enable */
      const workSheet = XLSX.utils.json_to_sheet(data);
      const workBook: import('xlsx').WorkBook = XLSX.utils.book_new();
      const wscols = [
        { width: 7 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 7 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 12 },
        { width: 7 },
        { width: 20 },
        { width: 20 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
        { width: 7 },
      ];
      workSheet['!cols'] = wscols;
      XLSX.utils.book_append_sheet(workBook, workSheet, 'Αποστολές');
      XLSX.writeFile(
        workBook,
        this.makeid(10) + '-' + this.makeid(4) + '.xlsx'
      );
    });
  }

  makeid(length) {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onAlertClose($event) {
    this.serverError.next(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onWarningClose($event) {
    this.customWarning.next(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onInfoClose($event) {
    this.customInfo.next(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onInfoClose2($event) {
    this.customInfo2.next(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onInfoClose3($event) {
    this.customInfo3.next(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onInfoClose4($event) {
    this.customInfo4.next(false);
  }

  createReceipt(return_f = false): any {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return new Promise((resolve, reject) => {
      let AAA: GConfig;

      this.store
        .pipe(
          select(selectGConfigById('general__AAA')),
          take(1),
          tap(res => (AAA = { ...res }))
        )
        .subscribe();

      AAA.value = '' + (parseInt(AAA.value) + 1);

      this.store.dispatch(new GConfigUpdate({ gconfig: AAA }));

      this.store
        .pipe(
          select(selectGConfigById('general__AAA')),
          takeWhile(
            (res: GConfig) => res.value !== '' + (parseInt(AAA.value) - 1),
            true
          ),
          takeUntil(
            this.actions$.pipe(
              ofType<GCActionFail>(GConfigActionTypes.GCActionFail)
            )
          ),
          takeUntil(
            this.actions$.pipe(
              ofType<GCActionSuccess>(GConfigActionTypes.GCActionSuccess)
            )
          )
        )
        .subscribe(res => {
          //Some level of error control on Action fail is required

          const user: User = this.fUsers[0];
          let ptext = '';
          if (!user.is_company) {
            ptext += `Πληρώσαμε τον/την ${user.lastname} ${user.firstname}, ιδιώτη, με `;
            if (user.adt !== '' && user.adt) {
              ptext += `ΑΔΤ ${user.adt} `;
            } else {
              ptext += `ΑΦΜ ${user.vat} `;
            }
            ptext += `και κωδικό αριθμό πελάτη ${user.kap}, διεύθυνση ${user.user_address} `;
            if (user.city && user.city !== '') {
              ptext += `${user.city} `;
            }
            ptext += `, τηλέφωνο ${
              user.mobile ? user.mobile : user.phone
            }, τις αντικαταβολές που εισπράξαμε για λογαριασμό του/της, σύμφωνα με την μεταξύ μας σύμβαση παροχής υπηρεσιών διαμεταφοράς.`;
          } else {
            ptext += `Πληρώσαμε την εταιρία ${user.companyName} , με ΑΦΜ ${user.companyVat} `;
            ptext += `και κωδικό αριθμό πελάτη ${user.kap}, διεύθυνση ${user.companyAddress} `;
            if (user.companyCity && user.companyCity !== '') {
              ptext += `${user.companyCity} `;
            }
            ptext += `, τηλέφωνο ${
              user.mobile ? user.mobile : user.phone
            }, τις αντικαταβολές που εισπράξαμε για λογαριασμό της, σύμφωνα με την μεταξύ μας σύμβαση παροχής υπηρεσιών διαμεταφοράς.`;
          }

          let apod = 0;
          let charges = 0;
          let echarges = 0;
          const ids: Array<number> = [];
          this.bigBucket
            .filter(
              row =>
                row._status === 'PAID_APPROVED' ||
                row._status === 'PROCESSED' ||
                row._status === 'RETURNED'
            )
            .forEach((elem: any) => {
              ids.push(elem.id);
              if (elem._status === 'PAID_APPROVED') {
                apod += parseFloat(
                  parseFloat('' + (elem.cod_ammount || 0)).toFixed(2)
                );
                if (elem.is_prereturn) {
                  apod -= parseFloat(
                    parseFloat('' + (elem.prereturn_ammount || 0)).toFixed(2)
                  );
                }
              }

              if (elem._status === 'RETURNED' && elem.is_prereturn) {
                apod -= parseFloat(
                  parseFloat('' + (elem.prereturn_ammount || 0)).toFixed(2)
                );
              }

              if (
                elem._status === 'PROCESSED' &&
                elem.is_cod &&
                parseFloat('' + elem.cod_ammount) > 0
              ) {
                this.store
                  .pipe(
                    select(selectUserById(this.bigBucket[0].user)),
                    take(1),
                    tap(res => {
                      if (res.allow_prereturns) {
                        if (elem.is_delivered && !elem.is_prereturn) {
                          const tmp_ammount =
                            (parseFloat(
                              parseFloat('' + (elem.cod_ammount || 0)).toFixed(
                                2
                              )
                            ) *
                              parseFloat('' + res.prereturn_perc)) /
                            100;
                          apod +=
                            tmp_ammount > parseFloat('' + res.prereturn_max)
                              ? parseFloat('' + res.prereturn_max)
                              : tmp_ammount;
                          charges +=
                            parseFloat(
                              parseFloat('' + res.prereturn_charge).toFixed(2)
                            ) *
                            (1 + parseFloat('' + res.vat_val) / 100);
                        }
                      }
                    })
                  )
                  .subscribe();
              }
              if (elem.is_prepaid === false) {
                charges += parseFloat(parseFloat(elem.cost || 0).toFixed(2));
              }

              if (
                elem.is_prepaid &&
                parseFloat(elem.cost).toFixed(2) !==
                  parseFloat(elem.prepaid_ammount).toFixed(2) &&
                elem.prepaid_ammount &&
                elem._status !== 'PROCESSED'
              ) {
                charges += parseFloat(parseFloat(elem.cost || 0).toFixed(2));
                charges -= parseFloat(
                  parseFloat(elem.prepaid_ammount || 0).toFixed(2)
                );
              }
            });

          this.extraCharges.forEach((elem: any) => {
            echarges += parseFloat(parseFloat(elem.charge || 0).toFixed(2));
          });

          const documentDefinition = {
            pageSize: 'A4',
            content: [
              {
                columns: [
                  [
                    {
                      image:
                        'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAMDAwMDAwMEBAMFBQQFBQcGBgYGBwoHCAcIBwoPCgsKCgsKDw4QDQwNEA4YExERExgcGBYYHCIeHiIrKSs4OEsBAwMDAwMDAwQEAwUFBAUFBwYGBgYHCgcIBwgHCg8KCwoKCwoPDhANDA0QDhgTERETGBwYFhgcIh4eIispKzg4S//AABEIAFAAyAMBIgACEQEDEQH/xACwAAADAAMAAwEBAAAAAAAAAAAACAkFBgcBAwQCChAAAQMDAgIECAsHAwUAAAAAAQIDBAAFBgcRCBITITFBFBUiMlFTYYEWI0JicXKUoaLR0hcYVYKTstNEkrEkVmSElQEAAQUBAQEAAAAAAAAAAAAAAAMEBQYHAgEIEQACAQMCAwUGBAQHAAAAAAABAgMABBEFEgYhMQcTFCJRFkFhcZKxUoGR0RUyQqEjJENTVmPB/9oADAMBAAIRAxEAPwCqdYXLcntOEY3dr/dFOJgQGeleLaeZe24ACB3kk1mqVzjKv/ivSFUFK9l3W5xo/wBKG93lf2U9061F7f2luc4klVTj0zzrh22Izegr1jjO0dA8y8/ZB+uvLfGbo5uAfHKR6fBB+upNUVpXsZo/rP8AWP2ph4qX4VbzCdd9LNQJDcWzZSyZy/NiyAYzyvqpcA5vdXT6/n4addYdbdacU24hQUhaSUqSR1ggjsIqwHC5qlO1JwAousgvXmzPCJIdPa8gjdpxXtIqr8QcMrpcIubeVnh3BWD9Vz0OR1FOILjvDtYYNMPRRWKk5ficB8R5WTWyO/vt0TstpCx9IKqqSo7nCqT8hmnVZWivDD7ElpDrLyHWlDdK0KCkkewivNc0VwbOuJbTfTjJZuPXfxiq4xkNqc8HYDiB0qQsDcqFGAcS+mmoGTQsetS7gifLDha8JYDaFFtJWRuFGpfa13z4R6sZ9cAvmQu7PtIPzGD0SfuTWp4bkcnEMrx6+xlEPW6czJG3eEKBUn3jqrSo+D7GTTkfMoumgDfzct5X0x0zTA3Th/dtzV5q4fqJxE6eaYZF4ivnjBU4R25BEZgOICXewElQrt9rnxbpbYE6K4FxpTDb7Sh18yHUhQNRl4j754+1pzp8L5mmJYho+iKgN1V+HNJh1S+minDiOOMsdpwc5ApxPKY0BXqTVK9OOIvANTciRYbEzczOUw4+S+wG2whrtJIUax2a8TemWAZPcsfuvjJyfCKA94PHDjYK0hYAPMKWHgZsyV5LnF7cT5EO3sxkq9r6ys/c3Sj6j39WU57mF4K+YTbpJdQfmFZCPw1OwcNadNrN9bDve4ghQnzc978+vypEzyCJG5ZJP6CqXjjQ0e9Xevsif10DjQ0e9Xevsif11Jyipj2N0f8A7/rpLxUvwqsaOM3SBZShLV6Kj1ACIP100zDofZadCSkLQlQChsRzDfY1DTSywnJ9R8JtPJzJk3aMlY+YlYUv8Iq5lVDibSrHSZbSO237nVmbc2eXQU6t5HkDFq80UUVV6cUUUUUUUUUUUUUVPLjqv3Pc8EsSF9TTEic4Pa6Q2iqG1Ijizv3jvWrIGgvdu2sRoKf5Ec6vxLq08Hwd9rKPjlFG7/r5f/ab3RxER6muD4zZ3MhyOw2hsHnnzmIo27R0ywiqWXvgn02Xa5otl4u8eeGlFlx11DqAvu508gqdmnWVRsHzbHcikWwzm7bJEgRgvo+dSQeXyiFbbGmuzTjZyC+WKdbrHijVqkSWlNGWuQX1tJX1EtgJSAqrnrkWvTXdmNPYpEB533ADJPvB64ppCYQrb+ZpIpDKoz77KyCptakHbs3SdqfXgWkLYnakla+WKiJCcWSdkgpLlIKSSSSdyaau0P3HS3hwu00c0e6Z5cRFj9yxb4yTzr/nJIp5r0XidPNqCO8uJI41+oMT+QBNcwna+73KCazfEDxO3zL7pOsOJ3J2DjbC1NLksKKHpxHUVcw6w1SdKUpalKUoqUTuSTuSa2zAsQm57mOP45EVyvXGUlor236NHatf8qQTVQM+4cdLrfpNkEK3Y2wzPt9sekMXHbeUXo6CvmWvvCu8U0kvdK4b8FZrCcy4yVAzjpuY10Ekn3vnpSC6Ia1ZDpVk1vPh7zuOvvIRPhLUS30ajsXEA+atNWIvV6i2zGbpeUupMePb3ZiVjsKUNlwEVAOqvZjkz1u4QYs55wiTLxmDDB7yZIQ1UTxXpkMt3pciIBJPMIXx/VnoaUtpCFkBPIDIqVEqQ5MlSZDp3cecU4s+lSzua9FFb7qLgs7T+9QbfK5j4VaoM9tR7xKZC1D+Ve4q7mSNJI4iwDMCVHqFxmmmCQTVOOFbPWr7ozHRKfBkY6Xob2/qmh0jR/2VKG/3Ny9X29XJw7rmzX5JPteWV12LRjU04JaNUrc5I5Grzjkhtjr/ANWgFLfvIWa4NUJpWmeB1LWZQuEmdCnyILH+5paSTfHEPeBVDuH1z4D8NOp+UnyHZKphZPpLTQZb/Gqp40/mozowng+wCyjyJF7XHWsex1SpaqQOjQh3smr3R/1rtwp9Vj8oom5CJfRfvTq6KYNw43TAoU3Or/Abvz8l8qaXclRltNBXKgFCVCut/s34L/8AuO2//Zc/XUz6KJ9EuJ55ZBrd5GHYkIj4Vc+4UCZQAO5Q1YLS/SXh/jXhnJcIUzNl2xxSA+xOclIaW4gjYgqI3KTSscRmqGseC6hZBj7OYymrLICJcEIaaQQw73BYSFeSoEUzHB9j/iTR2FLWjldu06RMP1QehT9yK0LjawYXHFLDlcZjd61P+CySPUSfNPuXVOspIPaSW1vG8ZCS1uGuAJOY6dfjTsl0iSSMmN1IcFOWKT3Dtas8+FNgTecyub1qXMablIMhafinDyKVuCPN33piY2VZXaL+uPLyO4KEaQtpwKkuEfFnY9ppAqcddw8fWbGb4FbquFua6c/+TG+Ie95KOb31Ve17Q4NOstJ1LT7ZLdY5jFKIVEYO8ZUkL8q1Tss1P+Iahqem38hn7+33xGbzlSnIhd3qDXR821UyLJbyZEO5y4UJptLTLTLqm9wO1auUjcqNatFyjMpb7bLWSXNS1kAASXfzrVQCSABuTTUaJabdJy365MeQk/EIUPOV6foFYnYrqWtahtFxJudtztkgKK1rV5NC4T0XebKAJEgSJCgLO3uHOux6Z47dLHZm37rcZcmfISCQ+6tzo0n6x7TRXRaK122t0tYI4UztQYyeZNfMt/eS6hdz3MuA8jE4UYA+AFflSkoSpSjslIJJ9AFQizu9qyTNcru6lb+G3SU+D81bhKfuq1eq19+DGmmb3UK5FR7TJLf11oKEfeahRWlcDQeW/nI6lIx9zUNeH+QfnX1sQJ0liQ+xCfdYZG7riG1KQ2PnEDYV8lU84ScKjT9EctExoFrI5UqOr2tIaDFTVvNrk2S73S2SUlMiFKdjOA9ymlFBq12OqR3t7qVsEwbZwuc53Z/Y03eMokbfiFNXw28PNq1OaOSXu7oNmhzSwu3M79M842AvZxXyUGtj43ZDcbJcCskZpLMKBZ1raaQOVCOkc5AAPYG69/A/l3gWVZNjDznxVxipmMJProvUr3lKqyHHTj8lu+YTfktkxnob0Fa+4ONL6RI94VVdM1x7YxRXEpMaoxgHQAMlLYXwpIHP31z7gwtrU3V9yQsAmFZ5LyPrLKG/+FVQLXm/M4zpBnc1xYSty2uRGva5K+KSPxVJjR/U2bpNmsPIY8MSmg0uPJjlXJ0rLvaAe4ggEV0XXjiMumsTMC2RbWbZYoznTFgudI4+92BThHcnuFdarod5f8QWk+0eFVULNkcthyVx8aI5kSBh/VzpbmGHZL7LDSCp11aUISO1SlHYCqO8Vy/gjojpviaTsouRWlj2QY+x/EaX3hW0ufznUGHd5UYmx2FxMp9ZHkuPp62Wq6Hxy3zwnM8Qs6V9UK2LkLHzpTn5N07v5ku+I9JtFOfDh5pPgceWuUBWCRvxYApO8UtK7/lGO2tCd1TrhGjf1XAmqB8beDIXj2I5NFY67c54tkEepdG7R9xFK1wxWPx7rZhiCjmbiOuzV/8ArtlQ/FVW9V8QRneneWWEoBdlQXOg9j7fltH/AHCmPEGp+C17RzuwkSkv8pTtP9hXcEe+GX1PT8qhPX12+G7cZ8KG0N3ZD7bKB6VOKCRXzutuMuONuIKVoUUqSeogjqINdY0Hsfwh1fwCEUcyBdG5C/qxt3j/AG1cbiYQW88x6Rxs/wBIzTVRlgPU0wnGfcW4EzTfEmFANWm0dKpA7ivZpH3N0q+m2KpzjPcUx9ZWGbhPaZeKOpQa33cI9oSDXReJzIfhFrTmLgXzNQnW4Df0RkBKvxVwhh9+M6l1h5bTqfNWhRSofQRUbpFtJFolrGr7JWhLbuuGk82fyJpSVgZmPuz9qqqeC/R8dk69/am/8dB4L9IB/rr39qb/AMdS78f33+NTf67n515Tfb8tSUi8ziSdgA+5+dRX8D1z/kkn0H96U76H/YFXfxbHLbiePWey28LEC3RkR2As7qKUd6j3k0v3FPqRjWIaeXSwTG0TLtfYy48eJv5ie+Qv0BB82tvuuZ2XQ7R3H5V4eU5Jh2qNGYYK93Zcroh5A9/nGpDZtmd9z/JLlfrzJLsyUvfb5DSB5raB3JSKrXDuiSahfPdSuxt4ZSd/QyuDml55QiBQPMR+lapTX4vbZuP4LabXcT/1rsp24IZPUYrMlCAG1/OXyhZHdXOdLcQZXtk90jhcKM6UQI7g3EuUj5RHe012q9J2FdluUW4NqZlTAsrmBTwWv5ZJ6zVX7X+LYTA2gWoWR8pJdv1EeDlU+daz2U8LyPdx65csY403par0MrEEM3xUCvVbXW2Z8Za0BSQsbg1S3EJkWdjVnejIShox0DkT2JKeo1MQEgg08mgl/Nxx1+Cpe646gtI+arqNZVwXdCO9mgOP8VMj5rVv7VdOafSrW8XP+Xkww+D8q7ZRRRWm1gNcn15wrJs+03umO48uMiZNfj9IqS4WkdE2sLV1gGkF/cs1g9fY/ta/8dVSoqb07iC/0uAw2/d7C5c7lycmkXgSQ5bNaBpLh8jT7TnFscfLXhcKKRJU0SUF5xRWspPo3NJ3rLwo5xmGo2R37HHrWi23FxMjlkPqaWl0pAc6gg1QOikbPWb2xvLi6iZe9m3b9wyDuOa6eJHUKegqdWlvDBrDgGfYvkfT2ZTMGWlT6US1krYX5DoHkd6TTy6laeWLUzEbhj91SUtO7LZfQAXGHkeY4mtwoovdZvb+5guZGVZogArINp5HIoSJEUqOhqTGS8IWsFlnvNW62xrxECj0b8Z9DZI9qHSkitiwfgx1EvU1leSvxrLbgQXQHEyJKh6EpRukVUWipZuMtYaHYO5VsY3hPN98Ul4WLOeda/hWE45p5jsKyWSCI8KOPpW4s+ctavlLVSV67cN2qOpupF5v9uctQty2mGYwekqQsIZbA6wEGn0oqGsdWvLC6kuo2DTOCGaQbs7jk0q8auoU9B6UmPDfw75jpXmN0vmRLt6gq3KjRvBni6QtxYKid0juFOdRRSWoX9xqVyZ5yN5AHlGBgV6iLGuB0qcepXCBn17zrJ7njy7Ui0Tpi5TCHny2tBe8taSAg9iq3fh+4a85001ATkV/VbVsR4EhDAjvlw9M6AkdqRTy0VKScTapLZtas0ZjMfdk7fMRjHWkxbxh93POc1L++cIOs17vV2ubz9kLs2Y9JVvLX2vLK/V1i/3LdYfXWT7Wv/HVVKKcrxhq6qAO5AAwPJXPhYvjUq/3LdYfXWT7Wv8Ax1m8Z4NtToeRWKTc3bQbczOYdlBuSpSy0hYKwAUVTmsJl+VW7DLDLus1Q5Wxs012KecPmoFJz8a6pHDK0kkKRhCWbZ0FLW+mm6nhhhjeSaRwqKOZYnoKnLxM4jqjkOWszb5NtbULy0Wu2sSlOGPHB89Y5AOZfeaXm1aZXB25Qk3KU0zALqfCFskrcDffyJIAKqYfI8huOUXmbdJ7vPIfXvt8lCe5CfQBWOgwnrhKZjsoKlrUAAKzB+1riWJjb2EdrFbL5Il7rLAevXrW9WPZNw/FZQvqMs73QTdMySbUB6kDl0Fb7g+KvZpfrdBhxBHtkVCWmWk9aGGG/wDk95PeaYzVvSqffLTi7GOwULct/SNKSVpb3bWAdyT7RW+6YYMzh9iZ6RsCc+kKdPeB3Jrf69sdCE1hc+Pd3urw95M+fPknd1NUzWuM5Ydcsn0pUSy00GO2jwdhG0oSQKQ79hOpX8Ga+0N/nXX9IsEzrDL2HbjbEtwnEqQsh5CtgfYDTJUV3acK6fZXEU8U0+9DkZYY+1Ian2i63q1jcWdxbWfdSqVbajgj5eaiiiirLVCoooooooooooooooooooooooooooooooooooooooooooooooor8SpUeFHfkPvJbZZQVuLUdkpSkbkk0gGqWoL+dXxSmlKRaYpUiI0e8d7ivnKp5MtxGLmFpVbJNwlR4y1hTvgykpLgT2JUSD1Vyn92/Cv4lc/6jf6Kq3Edlq+pIlvaqgt+rkvgufT5CtD4G1XhnQZJb3UHla95pEqxlhGvvOfxGkjAJNNdoVp3zqF+ns+Qg/EBQ7VVujHDthUZ5Dvh9xVyHfZa0bf212iBDj2+JHix2whhlAQhI7gKjNC4WntbsT3gTyc0UHdk1P8AGHaHZ6jpps9LaUGXlK7LswvoK91FFFXysdoooooooooooor/2Q==',
                      width: 130,
                      alignment: 'center',
                    },
                    {
                      text: 'Email: ronex.gr@gmail.com',
                      style: 'header_tiny',
                    },
                  ],
                  [
                    {
                      text: `ΑΠΟΔΕΙΞΗ ΠΛΗΡΩΜΗΣ Νο: ${user.kap}-${res.value}`,
                      alignment: 'center',
                      fontSize: 14,
                      bold: true,
                      margin: [0, 2, 0, 4],
                      color: '#444',
                    },
                    {
                      text: formatCurrency(apod, 'el-GR', '€'),
                      alignment: 'center',
                      fontSize: 18,
                      bold: true,
                      margin: [0, 0, 0, 4],
                      color: '#222',
                    },
                    {
                      text: 'ΑΠΟΔΟΣΗ ΑΝΤΙΚΑΤΑΒΟΛΩΝ',
                      alignment: 'center',
                      fontSize: 12,
                      bold: true,
                      color: '#444',
                    },
                    {
                      text: formatDate(Date.now(), 'dd/MM/yyyy', 'el-GR'),
                      alignment: 'center',
                      fontSize: 7,
                      bold: true,
                      color: '#444',
                    },
                  ],
                ],
              },
              {
                text: ptext,
                margin: [0, 40, 0, 4],
                color: '#222',
                lineHeight: 1.3,
                fontSize: 10,
                alignment: 'justify',
              },
              {
                columns: [
                  {},
                  [
                    {
                      text: 'Ο Εισπράξας',
                      alignment: 'center',
                      fontSize: 12,
                      bold: true,
                      margin: [0, 7, 0, 4],
                      color: '#222',
                      decoration: 'underline',
                    },
                    {
                      text: '( Υπογραφή, Ονοματεπώνυμο και Αριθμό Δελτίου Ταυτότοτας )',
                      alignment: 'center',
                      fontSize: 7,
                      bold: true,
                      margin: [0, 2, 0, 4],
                      color: '#666',
                    },
                    {
                      text: 'Ημερομηνία:    ____ / ____ / _______',
                      alignment: 'center',
                      fontSize: 9,
                      bold: true,
                      margin: [0, 50, 0, 4],
                      color: '#444',
                    },
                  ],
                ],
              },
              {
                margin: [0, 32, 0, 4],
                layout: {
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  fillColor: function (rowIndex, node, columnIndex) {
                    if (rowIndex === 0) {
                      return '#0b95bf';
                    }
                    if (rowIndex === 4) {
                      return '#9cd7ee';
                    }
                    return rowIndex % 2 === 0 ? '#e1f8ff' : '#fff';
                  },
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  hLineWidth: function (i, node) {
                    return 0.1;
                  },
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  vLineWidth: function (i, node) {
                    return 0.1;
                  },
                },
                table: {
                  headerRows: 1,
                  widths: ['*', 'auto'],
                  body: [
                    [
                      {
                        text: 'ΕΚΑΘΑΡΙΣΗ ΛΟΓΑΡΙΑΣΜΟΥ',
                        alignment: 'left',
                        fontSize: 9,
                        bold: true,
                        margin: [5, 4, 0, 4],
                        color: '#fff',
                      },
                      {
                        text: 'ΠΟΣΟ',
                        alignment: 'right',
                        fontSize: 9,
                        bold: true,
                        margin: [5, 4, 5, 4],
                        color: '#fff',
                      },
                    ],
                    [
                      {
                        text: 'Απόδοση Αντικαταβολών',
                        alignment: 'left',
                        fontSize: 8,
                        margin: [5, 4, 0, 4],
                        color: '#222',
                      },
                      {
                        text: formatCurrency(apod, 'el-GR', '€'),
                        alignment: 'right',
                        fontSize: 8,
                        bold: true,
                        margin: [5, 4, 5, 4],
                        color: '#222',
                      },
                    ],
                    [
                      {
                        text: 'Αποστολές με RoNEx - Συμψηφισμός',
                        alignment: 'left',
                        fontSize: 8,
                        margin: [5, 4, 0, 4],
                        color: '#222',
                      },
                      {
                        text: formatCurrency(-1 * charges, 'el-GR', '€'),
                        alignment: 'right',
                        fontSize: 8,
                        bold: true,
                        margin: [5, 4, 5, 4],
                        color: '#222',
                      },
                    ],
                    [
                      {
                        text: '',
                        alignment: 'right',
                        fontSize: 9,
                        bold: true,
                        margin: [5, 4, 0, 4],
                        color: '#222',
                      },
                      {
                        text: '    ',
                        alignment: 'right',
                        fontSize: 8,
                        bold: true,
                        margin: [5, 4, 5, 4],
                        color: '#222',
                      },
                    ],
                    [
                      {
                        text: 'ΣΥΝΟΛΟ',
                        alignment: 'right',
                        fontSize: 10,
                        bold: true,
                        margin: [5, 4, 9, 4],
                        color: '#222',
                      },
                      {
                        text: formatCurrency(
                          apod - charges - echarges,
                          'el-GR',
                          '€'
                        ),
                        alignment: 'right',
                        fontSize: 10,
                        bold: true,
                        margin: [5, 4, 5, 4],
                        color: '#222',
                      },
                    ],
                  ],
                },
              },
              {
                columns: [
                  {},
                  [
                    {
                      text: 'Ευχαριστούμε για την προτίμηση σας!',
                      alignment: 'center',
                      fontSize: 8,
                      bold: true,
                      margin: [0, 7, 0, 4],
                      color: '#222',
                    },
                    {
                      text: 'Ο Εισπράξας',
                      alignment: 'center',
                      fontSize: 12,
                      bold: true,
                      margin: [0, 7, 0, 4],
                      color: '#222',
                      decoration: 'underline',
                    },
                    {
                      text: '( Υπογραφή, Ονοματεπώνυμο και Αριθμό Δελτίου Ταυτότοτας )',
                      alignment: 'center',
                      fontSize: 7,
                      bold: true,
                      margin: [0, 2, 0, 4],
                      color: '#666',
                    },
                    {
                      text: 'Ημερομηνία:    ____ / ____ / _______',
                      alignment: 'center',
                      fontSize: 9,
                      bold: true,
                      margin: [0, 50, 0, 4],
                      color: '#444',
                    },
                  ],
                ],
              },
            ],
            styles: {
              header: {
                fontSize: 22,
                bold: true,
                color: '#444',
                alignment: 'center',
              },
              header_small: {
                fontSize: 10,
                alignment: 'center',
                color: '#222',
              },
              header_tiny: {
                fontSize: 7,
                alignment: 'center',
                color: '#444',
              },
            },
          };

          this.extraCharges.forEach((elem: any) => {
            const kk = [
              {
                text: elem.reason,
                alignment: 'left',
                fontSize: 8,
                margin: [5, 4, 0, 4],
                color: '#222',
              },
              {
                text: formatCurrency(
                  -1 * parseFloat(elem.charge),
                  'el-GR',
                  '€'
                ),
                alignment: 'right',
                fontSize: 8,
                bold: true,
                margin: [5, 4, 5, 4],
                color: '#222',
              },
            ];
            documentDefinition.content[3].table.body.splice(3, 0, kk);
          });
          const pp = this.extraCharges.length || 0;
          documentDefinition.content[3].layout.fillColor = function (
            rowIndex,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            node,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            columnIndex
          ) {
            if (rowIndex === 0) {
              return '#0b95bf';
            }
            if (rowIndex === 4 + pp) {
              return '#9cd7ee';
            }
            return rowIndex % 2 === 0 ? '#e1f8ff' : '#fff';
          };

          //console.log(documentDefinition);
          //pdfMake.vfs = pdfFonts.pdfMake.vfs;
          if (return_f) {
            pdfMake.createPdf(documentDefinition).getBlob(blob => {
              resolve({
                file: new File([blob], 'receipt.pdf', {
                  type: 'application/pdf',
                  lastModified: Date.now(),
                }),
                ids: ids,
                cod_sum: apod,
                charge_sum: charges + echarges,
                aaa: res.value,
              });
            });
          } else {
            pdfMake
              .createPdf(documentDefinition)
              .download(
                `${user.id}_${user.kap} ΑΠΟΔΕΙΞΗ ΕΙΣΠΡΑΞΗΣ ${this.dp.transform(
                  Date.now(),
                  'dd-MM-yyyy'
                )}.pdf`
              );
          }
        });
    });
  }

  //Handle bigBucket Selection
  toggleSelection(row: any) {
    this.selection.toggle(row);

    if (this.selection.isSelected(row)) {
      //Push object copy to the bucket
      this.bigBucket.push({ ...row });
    } else {
      //Remove object from the bucket
      this.bigBucket = this.bigBucket.filter(item => item.id !== row.id);
    }
  }

  clearSelection() {
    this.bigBucket.splice(0, this.bigBucket.length);
    this.selection.clear();
  }

  masterToggle() {
    if (this.selection.selected.length === this.shipmentsResult.length) {
      this.selection.selected.forEach(
        k => (this.bigBucket = this.bigBucket.filter(l => l.id !== k.id))
      );
      this.selection.clear();
    } else {
      this.shipmentsResult.forEach(row => {
        if (!this.selection.isSelected(row)) {
          this.selection.select(row);
          this.bigBucket.push({ ...row });
        }
      });
    }
  }

  restoreSelection() {
    this.shipmentsResult.forEach(sh => {
      if (this.bigBucket.filter(it => it.id === sh.id).length > 0) {
        this.selection.select(sh);
      }
    });
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.shipmentsResult.length;
    return numSelected === numRows;
  }

  selectAllByStatus(st: string) {
    if (this.selection.selected.filter(obj => obj._status === st).length > 0) {
      const tmp = this.selection.selected.filter(obj => obj._status !== st);
      const tr = this.selection.selected.filter(obj => obj._status === st);
      tr.forEach(
        atr => (this.bigBucket = this.bigBucket.filter(k => k.id !== atr.id))
      );
      this.selection.clear();
      tmp.forEach(row => this.selection.select(row));
    } else {
      this.shipmentsResult
        .filter(obj => obj._status === st)
        .forEach(row => {
          this.selection.select(row);
          this.bigBucket.push({ ...row });
        });
    }
  }

  s2ab(s: any): any {
    const buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
    const view = new Uint8Array(buf); //create uint8array as viewer
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
    return buf;
  }

  liquidate() {
    Promise.all([
      this.createCodXLS(true),
      this.createChargesXLS(true),
      this.createReceipt(true),
    ]).then(res => {
      const formData = new FormData();
      formData.append('cod_xls', res[0].file);
      formData.append('charge_xls', res[1].file);
      formData.append('receipt_pdf', res[2].file);
      formData.append(
        'data',
        JSON.stringify({
          uid: this.fUsers[0].id,
          cod_ids: res[0].ids,
          charge_ids: res[1].ids,
          receipt_ids: res[2].ids,
          cod_sum: res[2].cod_sum,
          charge_sum: res[2].charge_sum,
          aaa: res[2].aaa,
        })
      );

      // Store files temporarily for download after API success
      if (this.sDl) {
        this.pendingLiquidationFiles = {
          codFile: res[0].file,
          chargesFile: res[1].file,
          receiptFile: res[2].file,
          user: this.fUsers[0],
        };
      }

      this.store.dispatch(new Liquidate({ fdata: formData }));
      /*
				this.http.post<any>('api/shipments/liquidation/' , formData , {
					reportProgress: true,
					observe: 'events'
				}).pipe(
					map( event => {
						switch (event.type) {
							case HttpEventType.UploadProgress:
								console.log(`progress: ${ Math.round(event.loaded * 100 / event.total) }`);
							case HttpEventType.Response:
								return event;
						}
					})
				).subscribe(
					( event: any) => {
						if (typeof (event) === 'object') {
							console.log('uploaded success');
							console.log(event.body);
						}
					},
					err => {
						console.log('error');
					}
				);*/
    });
  }

  stateDl(event) {
    this.sDl = event.source._checked;
  }

  private onLiquidationSuccess() {
    if (this.pendingLiquidationFiles) {
      const { codFile, chargesFile, receiptFile, user } =
        this.pendingLiquidationFiles;

      saveAs(
        codFile,
        `${user.id}_${user.kap} ΑΠΟΔΟΣΗ ΑΝΤΙΚΑΤΑΒΟΛΩΝ ${this.dp.transform(
          Date.now(),
          'dd-MM-yyyy'
        )}.xlsx`
      );
      saveAs(
        chargesFile,
        `${user.id}_${user.kap} ΑΝΑΛΥΣΗ ΧΡΕΩΣΕΩΝ ${this.dp.transform(
          Date.now(),
          'dd-MM-yyyy'
        )}.xlsx`
      );
      saveAs(
        receiptFile,
        `${user.id}_${user.kap} ΑΠΟΔΕΙΞΗ ΕΙΣΠΡΑΞΗΣ ${this.dp.transform(
          Date.now(),
          'dd-MM-yyyy'
        )}.pdf`
      );

      this.pendingLiquidationFiles = null;
    }

    // Clear extra charges only on successful liquidation
    this.clearExtraCharges();
  }

  private onLiquidationFailed() {
    // Clear pending files on failure - don't download
    this.pendingLiquidationFiles = null;
  }

  private guid() {
    const uniqueId =
      Math.random().toString(36).substring(2) +
      new Date().getTime().toString(36);
    return uniqueId;
  }
}
